import { c as segmentationSortOrder, d as allSegmentationSigns, e as segmentationSeparatorForLocationCode, f as segmentationSeparator, h as allSegmentationOperators } from './shared.sThvusWW.mjs';
import { z } from 'zod';

const analyticsAttributes = [
  "about.businessType",
  "about.industries",
  "about.industry",
  "about.totalEmployees",
  "about.yearFounded",
  "analytics.monthlyVisitors",
  "apps",
  "codes.naics",
  "codes.sic",
  "contacts",
  "domain.tld",
  "finances.revenue",
  "finances.stockExchange",
  "locations.headquarters.city.code",
  "locations.headquarters.continent.code",
  "locations.headquarters.country.code",
  "locations.headquarters.county.code",
  "locations.headquarters.state.code",
  "meta.score",
  "meta.syncedAt",
  "socials",
  "technologies.active",
  "technologies.categories"
];
const analyticsData = { analyticsAttributes };

const companiesV2CategoriesMapping = {
  about: true,
  analytics: true,
  apps: true,
  assets: true,
  careers: true,
  codes: true,
  companies: true,
  contacts: true,
  contents: true,
  descriptions: true,
  domain: true,
  finances: true,
  legals: true,
  locations: true,
  meta: true,
  products: true,
  secondaries: true,
  socials: true,
  sources: true,
  technologies: true
};
const companiesV2AttributesMapping = {
  "about.businessType": true,
  "about.industries": true,
  "about.industry": true,
  "about.languages": true,
  "about.name": true,
  "about.nameAlts": true,
  "about.nameLegal": true,
  "about.totalEmployees": true,
  "about.totalEmployeesExact": true,
  "about.yearFounded": true,
  "about.yearFoundedDate": true,
  "about.yearFoundedPlace": true,
  "analytics.lighthouse": true,
  "analytics.monthlyVisitors": true,
  "apps.amazon": true,
  "apps.android": true,
  "apps.chrome": true,
  "apps.ios": true,
  "apps.mac": true,
  "apps.meta": true,
  "apps.microsoft": true,
  "apps.playstation": true,
  "apps.xbox": true,
  "assets.colorPrimary": true,
  "assets.cover": true,
  "assets.logoSquare": true,
  "codes.naics": true,
  "codes.sic": true,
  "companies.acquisitions": true,
  "companies.parent": true,
  "companies.subsidiaries": true,
  "contacts.emails": true,
  "contacts.lines": true,
  "contacts.phones": true,
  "contacts.whatsapps": true,
  "contents.podcasts": true,
  "descriptions.knowledgeGraph": true,
  "descriptions.linkedin": true,
  "descriptions.primary": true,
  "descriptions.tagline": true,
  "descriptions.website": true,
  "descriptions.wikipedia": true,
  "domain.alias": true,
  "domain.createdAt": true,
  "domain.domain": true,
  "domain.domainAlts": true,
  "domain.domainName": true,
  "domain.expiredAt": true,
  "domain.nsfw": true,
  "domain.redirection": true,
  "domain.registrantCountry": true,
  "domain.registrantPhone": true,
  "domain.registrar": true,
  "domain.root": true,
  "domain.state": true,
  "domain.status": true,
  "domain.tld": true,
  "domain.updatedAt": true,
  "finances.revenue": true,
  "finances.stockExchange": true,
  "finances.stockSymbol": true,
  "locations.headquarters": true,
  "locations.headquarters.address": true,
  "locations.headquarters.city.code": true,
  "locations.headquarters.city.geopoint": true,
  "locations.headquarters.city.name": true,
  "locations.headquarters.city.postcode": true,
  "locations.headquarters.continent.code": true,
  "locations.headquarters.continent.geopoint": true,
  "locations.headquarters.continent.name": true,
  "locations.headquarters.country.code": true,
  "locations.headquarters.country.geopoint": true,
  "locations.headquarters.country.name": true,
  "locations.headquarters.county.code": true,
  "locations.headquarters.county.geopoint": true,
  "locations.headquarters.county.name": true,
  "locations.headquarters.state.code": true,
  "locations.headquarters.state.geopoint": true,
  "locations.headquarters.state.name": true,
  "meta.geopoint": true,
  "meta.ideated": true,
  "meta.listIds": true,
  "meta.mysqlId": true,
  "meta.new": true,
  "meta.pageContents": true,
  "meta.score": true,
  "meta.similarAttributes": true,
  "meta.similarity": true,
  "meta.syncedAt": true,
  "secondaries.emailPatterns": true,
  "socials.discord": true,
  "socials.discord.id": true,
  "socials.discord.members": true,
  "socials.discord.url": true,
  "socials.dribbble": true,
  "socials.dribbble.id": true,
  "socials.dribbble.url": true,
  "socials.facebook": true,
  "socials.facebook.followers": true,
  "socials.facebook.id": true,
  "socials.facebook.likes": true,
  "socials.facebook.talkingAbout": true,
  "socials.facebook.url": true,
  "socials.facebook.wereHere": true,
  "socials.facebookGroup": true,
  "socials.facebookGroup.id": true,
  "socials.facebookGroup.members": true,
  "socials.facebookGroup.url": true,
  "socials.github": true,
  "socials.github.followers": true,
  "socials.github.id": true,
  "socials.github.members": true,
  "socials.github.url": true,
  "socials.instagram": true,
  "socials.instagram.followers": true,
  "socials.instagram.following": true,
  "socials.instagram.id": true,
  "socials.instagram.posts": true,
  "socials.instagram.url": true,
  "socials.linkedin": true,
  "socials.linkedin.followers": true,
  "socials.linkedin.id": true,
  "socials.linkedin.idNumeric": true,
  "socials.linkedin.salesNavigatorUrl": true,
  "socials.linkedin.url": true,
  "socials.mastodon": true,
  "socials.mastodon.followers": true,
  "socials.mastodon.following": true,
  "socials.mastodon.id": true,
  "socials.mastodon.posts": true,
  "socials.mastodon.url": true,
  "socials.medium": true,
  "socials.medium.followers": true,
  "socials.medium.id": true,
  "socials.medium.url": true,
  "socials.patreon": true,
  "socials.patreon.id": true,
  "socials.patreon.members": true,
  "socials.patreon.posts": true,
  "socials.patreon.url": true,
  "socials.pinterest": true,
  "socials.pinterest.followers": true,
  "socials.pinterest.following": true,
  "socials.pinterest.id": true,
  "socials.pinterest.monthlyViews": true,
  "socials.pinterest.url": true,
  "socials.reddit": true,
  "socials.reddit.id": true,
  "socials.reddit.members": true,
  "socials.reddit.url": true,
  "socials.slack": true,
  "socials.slack.id": true,
  "socials.slack.members": true,
  "socials.slack.url": true,
  "socials.snapchat": true,
  "socials.snapchat.followers": true,
  "socials.snapchat.id": true,
  "socials.snapchat.url": true,
  "socials.stackoverflow": true,
  "socials.stackoverflow.id": true,
  "socials.stackoverflow.posts": true,
  "socials.stackoverflow.url": true,
  "socials.steam": true,
  "socials.steam.id": true,
  "socials.steam.members": true,
  "socials.steam.url": true,
  "socials.substack": true,
  "socials.substack.followers": true,
  "socials.substack.id": true,
  "socials.substack.url": true,
  "socials.threads": true,
  "socials.threads.followers": true,
  "socials.threads.id": true,
  "socials.threads.url": true,
  "socials.tiktok": true,
  "socials.tiktok.followers": true,
  "socials.tiktok.following": true,
  "socials.tiktok.id": true,
  "socials.tiktok.likes": true,
  "socials.tiktok.url": true,
  "socials.tumblr": true,
  "socials.tumblr.id": true,
  "socials.tumblr.url": true,
  "socials.twitch": true,
  "socials.twitch.followers": true,
  "socials.twitch.id": true,
  "socials.twitch.url": true,
  "socials.twitter": true,
  "socials.twitter.followers": true,
  "socials.twitter.following": true,
  "socials.twitter.id": true,
  "socials.twitter.url": true,
  "socials.vimeo": true,
  "socials.vimeo.followers": true,
  "socials.vimeo.following": true,
  "socials.vimeo.id": true,
  "socials.vimeo.url": true,
  "socials.vimeo.videos": true,
  "socials.vkontakte": true,
  "socials.vkontakte.followers": true,
  "socials.vkontakte.id": true,
  "socials.vkontakte.url": true,
  "socials.wellfound": true,
  "socials.wellfound.id": true,
  "socials.wellfound.url": true,
  "socials.xing": true,
  "socials.xing.followers": true,
  "socials.xing.id": true,
  "socials.xing.url": true,
  "socials.yelp": true,
  "socials.yelp.id": true,
  "socials.yelp.rating": true,
  "socials.yelp.reviews": true,
  "socials.yelp.url": true,
  "socials.youtube": true,
  "socials.youtube.followers": true,
  "socials.youtube.id": true,
  "socials.youtube.url": true,
  "socials.youtube.videos": true,
  "technologies.active": true,
  "technologies.categories": true,
  "technologies.details": true,
  "urls.about": true,
  "urls.blog": true,
  "urls.careers": true,
  "urls.contact": true,
  "urls.crunchbase": true,
  "urls.developers": true,
  "urls.docs": true,
  "urls.events": true,
  "urls.glassdoor": true,
  "urls.partnership": true,
  "urls.pricing": true,
  "urls.privacy": true,
  "urls.registrar": true,
  "urls.salesNavigator": true,
  "urls.sitemap": true,
  "urls.status": true,
  "urls.terms": true,
  "urls.updates": true,
  "urls.website": true,
  "urls.wellfound": true,
  "urls.wikidata": true,
  "urls.wikipedia": true
};
const companiesV2Categories = Object.keys(companiesV2CategoriesMapping);
const companiesV2Attributes = Object.keys(companiesV2AttributesMapping);
const companiesV2CategoriesAndAttributes = Object.keys({
  ...companiesV2CategoriesMapping,
  ...companiesV2AttributesMapping
});
const companiesV2AttributesSimplified = [
  "about.industry",
  "about.name",
  "assets.logoSquare",
  "descriptions.tagline",
  "domain.domain",
  "meta.syncedAt"
];
const companiesV2AttributesFirstLevel = [
  "about.businessType",
  "about.industries",
  "about.industry",
  "about.languages",
  "about.name",
  "about.nameAlts",
  "about.nameLegal",
  "about.totalEmployees",
  "about.totalEmployeesExact",
  "about.yearFounded",
  "about.yearFoundedDate",
  "about.yearFoundedPlace",
  "analytics.lighthouse",
  "analytics.monthlyVisitors",
  "apps.amazon",
  "apps.android",
  "apps.chrome",
  "apps.ios",
  "apps.mac",
  "apps.meta",
  "apps.microsoft",
  "apps.playstation",
  "apps.xbox",
  "assets.colorPrimary",
  "assets.cover",
  "assets.logoSquare",
  "codes.naics",
  "codes.sic",
  "companies.acquisitions",
  "companies.parent",
  "companies.subsidiaries",
  "contacts.emails",
  "contacts.lines",
  "contacts.phones",
  "contacts.whatsapps",
  "contents.podcasts",
  "descriptions.knowledgeGraph",
  "descriptions.linkedin",
  "descriptions.primary",
  "descriptions.tagline",
  "descriptions.website",
  "descriptions.wikipedia",
  "domain.alias",
  "domain.createdAt",
  "domain.domain",
  "domain.domainAlts",
  "domain.domainName",
  "domain.expiredAt",
  "domain.nsfw",
  "domain.redirection",
  "domain.registrantCountry",
  "domain.registrantPhone",
  "domain.registrar",
  "domain.root",
  "domain.state",
  "domain.status",
  "domain.tld",
  "domain.updatedAt",
  "finances.revenue",
  "finances.stockExchange",
  "finances.stockSymbol",
  "locations.headquarters",
  "meta.geopoint",
  "meta.ideated",
  "meta.listIds",
  "meta.mysqlId",
  "meta.new",
  "meta.pageContents",
  "meta.score",
  "meta.similarAttributes",
  "meta.similarity",
  "meta.syncedAt",
  "secondaries.emailPatterns",
  "socials.discord",
  "socials.dribbble",
  "socials.facebook",
  "socials.facebookGroup",
  "socials.github",
  "socials.instagram",
  "socials.linkedin",
  "socials.mastodon",
  "socials.medium",
  "socials.patreon",
  "socials.pinterest",
  "socials.reddit",
  "socials.slack",
  "socials.snapchat",
  "socials.stackoverflow",
  "socials.steam",
  "socials.substack",
  "socials.threads",
  "socials.tiktok",
  "socials.tumblr",
  "socials.twitch",
  "socials.twitter",
  "socials.vimeo",
  "socials.vkontakte",
  "socials.wellfound",
  "socials.xing",
  "socials.yelp",
  "socials.youtube",
  "technologies.active",
  "technologies.categories",
  "technologies.details",
  "urls.about",
  "urls.blog",
  "urls.careers",
  "urls.contact",
  "urls.crunchbase",
  "urls.developers",
  "urls.docs",
  "urls.events",
  "urls.glassdoor",
  "urls.partnership",
  "urls.pricing",
  "urls.privacy",
  "urls.registrar",
  "urls.salesNavigator",
  "urls.sitemap",
  "urls.status",
  "urls.terms",
  "urls.updates",
  "urls.website",
  "urls.wellfound",
  "urls.wikidata",
  "urls.wikipedia"
];
const companiesV2AttributesNextLevels = [
  "locations.headquarters.address",
  "locations.headquarters.city.code",
  "locations.headquarters.city.geopoint",
  "locations.headquarters.city.name",
  "locations.headquarters.city.postcode",
  "locations.headquarters.continent.code",
  "locations.headquarters.continent.geopoint",
  "locations.headquarters.continent.name",
  "locations.headquarters.country.code",
  "locations.headquarters.country.geopoint",
  "locations.headquarters.country.name",
  "locations.headquarters.county.code",
  "locations.headquarters.county.geopoint",
  "locations.headquarters.county.name",
  "locations.headquarters.state.code",
  "locations.headquarters.state.geopoint",
  "locations.headquarters.state.name",
  "socials.discord.id",
  "socials.discord.members",
  "socials.discord.url",
  "socials.dribbble.id",
  "socials.dribbble.url",
  "socials.facebook.followers",
  "socials.facebook.id",
  "socials.facebook.likes",
  "socials.facebook.talkingAbout",
  "socials.facebook.url",
  "socials.facebook.wereHere",
  "socials.facebookGroup.id",
  "socials.facebookGroup.members",
  "socials.facebookGroup.url",
  "socials.github.followers",
  "socials.github.id",
  "socials.github.members",
  "socials.github.url",
  "socials.instagram.followers",
  "socials.instagram.following",
  "socials.instagram.id",
  "socials.instagram.posts",
  "socials.instagram.url",
  "socials.linkedin.followers",
  "socials.linkedin.id",
  "socials.linkedin.idNumeric",
  "socials.linkedin.salesNavigatorUrl",
  "socials.linkedin.url",
  "socials.mastodon.followers",
  "socials.mastodon.following",
  "socials.mastodon.id",
  "socials.mastodon.posts",
  "socials.mastodon.url",
  "socials.medium.followers",
  "socials.medium.id",
  "socials.medium.url",
  "socials.patreon.id",
  "socials.patreon.members",
  "socials.patreon.posts",
  "socials.patreon.url",
  "socials.pinterest.followers",
  "socials.pinterest.following",
  "socials.pinterest.id",
  "socials.pinterest.monthlyViews",
  "socials.pinterest.url",
  "socials.reddit.id",
  "socials.reddit.members",
  "socials.reddit.url",
  "socials.slack.id",
  "socials.slack.members",
  "socials.slack.url",
  "socials.snapchat.followers",
  "socials.snapchat.id",
  "socials.snapchat.url",
  "socials.stackoverflow.id",
  "socials.stackoverflow.posts",
  "socials.stackoverflow.url",
  "socials.steam.id",
  "socials.steam.members",
  "socials.steam.url",
  "socials.substack.followers",
  "socials.substack.id",
  "socials.substack.url",
  "socials.threads.followers",
  "socials.threads.id",
  "socials.threads.url",
  "socials.tiktok.followers",
  "socials.tiktok.following",
  "socials.tiktok.id",
  "socials.tiktok.likes",
  "socials.tiktok.url",
  "socials.tumblr.id",
  "socials.tumblr.url",
  "socials.twitch.followers",
  "socials.twitch.id",
  "socials.twitch.url",
  "socials.twitter.followers",
  "socials.twitter.following",
  "socials.twitter.id",
  "socials.twitter.url",
  "socials.vimeo.followers",
  "socials.vimeo.following",
  "socials.vimeo.id",
  "socials.vimeo.url",
  "socials.vimeo.videos",
  "socials.vkontakte",
  "socials.vkontakte.followers",
  "socials.vkontakte.id",
  "socials.vkontakte.url",
  "socials.wellfound.id",
  "socials.wellfound.url",
  "socials.xing.followers",
  "socials.xing.id",
  "socials.xing.url",
  "socials.yelp.id",
  "socials.yelp.rating",
  "socials.yelp.reviews",
  "socials.yelp.url",
  "socials.youtube.followers",
  "socials.youtube.id",
  "socials.youtube.url",
  "socials.youtube.videos"
];

const costs = {
  actions: {
    "cleanup-list": 0,
    "enrich-companies": 1,
    "enrich-list": 1
  },
  globals: {
    action: 1,
    ask: 10,
    askLarge: 100,
    company: 1,
    companySimilar: 5,
    context: 5
  },
  v1: {
    company: 1,
    companySimilar: 1,
    search: 0.25
  }
};

const countries = [
  {
    code: "ad",
    continent: "Europe",
    continentCode: "eu",
    latitude: "42.5407167",
    linkedinHeadline: "Andorra",
    linkedinId: "106296266",
    longitude: "1.5732033",
    name: {
      en: "Andorra",
      es: "Andorra",
      fr: "Andorre",
      native: ["Andorra"]
    },
    population: 77e3
  },
  {
    code: "ae",
    continent: "Asia",
    continentCode: "as",
    latitude: "24.0002488",
    linkedinHeadline: "United Arab Emirates",
    linkedinId: "104305776",
    longitude: "53.9994829",
    name: {
      en: "United Arab Emirates",
      es: "Emiratos \xC1rabes Unidos",
      fr: "\xC9mirats arabes unis",
      native: ["\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629"]
    },
    population: 9891e3
  },
  {
    code: "af",
    continent: "Asia",
    continentCode: "as",
    latitude: "33.7680065",
    linkedinHeadline: "Afghanistan",
    linkedinId: "101240012",
    longitude: "66.2385139",
    name: {
      en: "Afghanistan",
      es: "Afganist\xE1n",
      fr: "Afghanistan",
      native: ["\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646"]
    },
    population: 38928e3
  },
  {
    code: "ag",
    continent: "North America",
    continentCode: "na",
    latitude: "17.2234721",
    linkedinHeadline: "Antigua and Barbuda",
    linkedinId: "100270819",
    longitude: "-61.9554608",
    name: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      fr: "Antigua-et-Barbuda",
      native: ["Antigua and Barbuda"]
    },
    population: 98e3
  },
  {
    code: "ai",
    continent: "North America",
    continentCode: "na",
    latitude: "18.1954947",
    linkedinHeadline: "Anguilla",
    linkedinId: "102287072",
    longitude: "-63.0750234",
    name: {
      en: "Anguilla",
      es: "Anguila",
      fr: "Anguilla",
      native: ["Anguilla"]
    },
    population: 15e3
  },
  {
    code: "al",
    continent: "Europe",
    continentCode: "eu",
    latitude: "41.000028",
    linkedinHeadline: "Albania",
    linkedinId: "102845717",
    longitude: "19.9999619",
    name: {
      en: "Albania",
      es: "Albania",
      fr: "Albanie",
      native: ["Shqip\xEBria"]
    },
    population: 2878e3
  },
  {
    code: "am",
    continent: "Asia",
    continentCode: "as",
    latitude: "40.7696272",
    linkedinHeadline: "Armenia",
    linkedinId: "103030111",
    longitude: "44.6736646",
    name: {
      en: "Armenia",
      es: "Armenia",
      fr: "Arm\xE9nie",
      native: ["\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576"]
    },
    population: 2963e3
  },
  {
    code: "ao",
    continent: "Africa",
    continentCode: "af",
    latitude: "-11.8775768",
    linkedinHeadline: "Angola",
    linkedinId: "105371935",
    longitude: "17.5691241",
    name: {
      en: "Angola",
      es: "Angola",
      fr: "Angola",
      native: ["Angola"]
    },
    population: 32866e3
  },
  {
    code: "aq",
    continent: "Antarctica",
    continentCode: "an",
    latitude: "-72.8438691",
    linkedinHeadline: "Antarctica",
    linkedinId: "100428639",
    longitude: "0",
    name: {
      en: "Antarctica",
      es: "Ant\xE1rtida",
      fr: "Antarctique",
      native: ["Antarctica"]
    },
    population: 1e3
  },
  {
    code: "ar",
    continent: "South America",
    continentCode: "sa",
    latitude: "-34.9964963",
    linkedinHeadline: "Argentina",
    linkedinId: "100446943",
    longitude: "-64.9672817",
    name: {
      en: "Argentina",
      es: "Argentina",
      fr: "Argentine",
      native: ["Argentina"]
    },
    population: 45377e3
  },
  {
    code: "as",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-14.289304",
    linkedinHeadline: "American Samoa",
    linkedinId: "102431220",
    longitude: "-170.692511",
    name: {
      en: "American Samoa",
      es: "Samoa Americana",
      fr: "Samoa 1m\xE9ricaines",
      native: ["Amerika S\u0101moa"]
    },
    population: 55e3
  },
  {
    code: "at",
    continent: "Europe",
    continentCode: "eu",
    latitude: "47.2000338",
    linkedinHeadline: "Austria",
    linkedinId: "103883259",
    longitude: "13.199959",
    name: {
      en: "Austria",
      es: "Austria",
      fr: "Autriche",
      native: ["\xD6sterreich"]
    },
    population: 9013e3
  },
  {
    code: "au",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-24.7761086",
    linkedinHeadline: "Australia",
    linkedinId: "101452733",
    longitude: "134.755",
    name: {
      en: "Australia",
      es: "Australia",
      fr: "Australie",
      native: ["Australia"]
    },
    population: 25767e3
  },
  {
    code: "aw",
    continent: "North America",
    continentCode: "na",
    latitude: "12.4902998",
    linkedinHeadline: "Aruba",
    linkedinId: "105763200",
    longitude: "-69.9609842",
    name: {
      en: "Aruba",
      es: "Aruba",
      fr: "Aruba",
      native: ["Aruba"]
    },
    population: 107e3
  },
  {
    code: "ax",
    continent: "Europe",
    continentCode: "eu",
    latitude: "60.1603621",
    linkedinHeadline: "\xC5land Islands, Finland",
    linkedinId: "106452055",
    longitude: "20.08317860965865",
    name: {
      en: "Aland Islands",
      es: "Islas Aland",
      fr: "Iles Aland",
      native: ["\xC5land"]
    },
    population: 3e4
  },
  {
    code: "az",
    continent: "Asia",
    continentCode: "as",
    latitude: "40.3936294",
    linkedinHeadline: "Azerbaijan",
    linkedinId: "103226548",
    longitude: "47.7872508",
    name: {
      en: "Azerbaijan",
      es: "Azerbaiy\xE1n",
      fr: "Azerba\xEFdjan",
      native: ["Az\u0259rbaycan"]
    },
    population: 10221e3
  },
  {
    code: "ba",
    continent: "Europe",
    continentCode: "eu",
    latitude: "44.3053476",
    linkedinHeadline: "Bosnia and Herzegovina",
    linkedinId: "102869081",
    longitude: "17.5961467",
    name: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      fr: "Bosnie Herz\xE9govine",
      native: ["Bosna i Hercegovina"]
    },
    population: 328e4
  },
  {
    code: "bb",
    continent: "North America",
    continentCode: "na",
    latitude: "13.1500331",
    linkedinHeadline: "Barbados",
    linkedinId: "102118611",
    longitude: "-59.5250305",
    name: {
      en: "Barbados",
      es: "Barbados",
      fr: "Barbade",
      native: ["Barbados"]
    },
    population: 287e3
  },
  {
    code: "bd",
    continent: "Asia",
    continentCode: "as",
    latitude: "24.4768783",
    linkedinHeadline: "Bangladesh",
    linkedinId: "106215326",
    longitude: "90.2932426",
    name: {
      en: "Bangladesh",
      es: "Bangladesh",
      fr: "Bangladesh",
      native: ["\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6"]
    },
    population: 166375e3
  },
  {
    code: "be",
    continent: "Europe",
    continentCode: "eu",
    latitude: "50.6402809",
    linkedinHeadline: "Belgium",
    linkedinId: "100565514",
    longitude: "4.6667145",
    name: {
      en: "Belgium",
      es: "B\xE9lgica",
      fr: "Belgique",
      native: ["Belgi\xEB", "Belgique"]
    },
    population: 11633e3
  },
  {
    code: "bf",
    continent: "Africa",
    continentCode: "af",
    latitude: "12.0753083",
    linkedinHeadline: "Burkina Faso",
    linkedinId: "100587095",
    longitude: "-1.6880314",
    name: {
      en: "Burkina Faso",
      es: "Burkina Faso",
      fr: "Burkina Faso",
      native: ["Burkina Faso"]
    },
    population: 21497e3
  },
  {
    code: "bg",
    continent: "Europe",
    continentCode: "eu",
    latitude: "42.6073975",
    linkedinHeadline: "Bulgaria",
    linkedinId: "105333783",
    longitude: "25.4856617",
    name: {
      en: "Bulgaria",
      es: "Bulgaria",
      fr: "Bulgarie",
      native: ["\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F"]
    },
    population: 6925e3
  },
  {
    code: "bh",
    continent: "Asia",
    continentCode: "as",
    latitude: "26.1551249",
    linkedinHeadline: "Bahrain",
    linkedinId: "100425729",
    longitude: "50.5344606",
    name: {
      en: "Bahrain",
      es: "Bahr\xE9in",
      fr: "Bahre\xEFn",
      native: ["\u0627\u0644\u0628\u062D\u0631\u064A\u0646"]
    },
    population: 1702e3
  },
  {
    code: "bi",
    continent: "Africa",
    continentCode: "af",
    latitude: "-3.3634357",
    linkedinHeadline: "Burundi",
    linkedinId: "100800406",
    longitude: "29.8870575",
    name: {
      en: "Burundi",
      es: "Burundi",
      fr: "Burundi",
      native: ["Burundi"]
    },
    population: 12155e3
  },
  {
    code: "bj",
    continent: "Africa",
    continentCode: "af",
    latitude: "9.5293472",
    linkedinHeadline: "Benin",
    linkedinId: "101519029",
    longitude: "2.2584408",
    name: {
      en: "Benin",
      es: "Benin",
      fr: "B\xE9nin",
      native: ["B\xE9nin"]
    },
    population: 12451e3
  },
  {
    code: "bl",
    continent: "North America",
    continentCode: "na",
    latitude: "17.9036287",
    linkedinHeadline: "Saint-Barthelemy",
    linkedinId: "100936035",
    longitude: "-62.811568843006896",
    name: {
      en: "Saint-Barthelemy",
      es: "Saint-Barthelemy",
      fr: "Saint-Barth\xE9lemy",
      native: ["Saint-Barth\xE9lemy"]
    },
    population: 1e4
  },
  {
    code: "bm",
    continent: "North America",
    continentCode: "na",
    latitude: "32.3018217",
    linkedinHeadline: "Bermuda",
    linkedinId: "100061709",
    longitude: "-64.7603583",
    name: {
      en: "Bermuda",
      es: "Bermudas",
      fr: "Bermudes",
      native: ["Bermuda"]
    },
    population: 62e3
  },
  {
    code: "bn",
    continent: "Asia",
    continentCode: "as",
    latitude: "4.4137155",
    linkedinHeadline: "Brunei",
    linkedinId: "103809722",
    longitude: "114.5653908",
    name: {
      en: "Brunei Darussalam",
      es: "Brunei Darussalam",
      fr: "Brunei Darussalam",
      native: ["Brunei"]
    },
    population: 438e3
  },
  {
    code: "bo",
    continent: "South America",
    continentCode: "sa",
    latitude: "-17.0568696",
    linkedinHeadline: "Bolivia",
    linkedinId: "104379274",
    longitude: "-64.9912286",
    name: {
      en: "Bolivia",
      es: "Bolivia",
      fr: "Bolivie",
      native: ["Bolivia"]
    },
    population: 11833e3
  },
  {
    code: "bq",
    continent: "South America",
    continentCode: "sa",
    latitude: "17.566000000000003",
    linkedinHeadline: null,
    linkedinId: null,
    longitude: "-63.143238651638256",
    name: {
      en: "Caribbean Netherlands",
      es: "Caribe Neerland\xE9s",
      fr: "Pays-Bas Carib\xE9ens",
      native: ["Caribisch Nederland"]
    },
    population: 26e3
  },
  {
    code: "br",
    continent: "South America",
    continentCode: "sa",
    latitude: "-10.3333333",
    linkedinHeadline: "Brazil",
    linkedinId: "106057199",
    longitude: "-53.2",
    name: {
      en: "Brazil",
      es: "Brasil",
      fr: "Br\xE9sil",
      native: ["Brasil"]
    },
    population: 213993e3
  },
  {
    code: "bs",
    continent: "North America",
    continentCode: "na",
    latitude: "24.7736546",
    linkedinHeadline: "The Bahamas",
    linkedinId: "106662619",
    longitude: "-78.0000547",
    name: {
      en: "The Bahamas",
      es: "Las Bahamas",
      fr: "Les Bahamas",
      native: ["Bahamas"]
    },
    population: 396e3
  },
  {
    code: "bt",
    continent: "Asia",
    continentCode: "as",
    latitude: "27.549511",
    linkedinHeadline: "Bhutan",
    linkedinId: "103613266",
    longitude: "90.5119273",
    name: {
      en: "Bhutan",
      es: "But\xE1n",
      fr: "Bhoutan",
      native: ["\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F61\u0F74\u0F63\u0F0D"]
    },
    population: 776e3
  },
  {
    code: "bv",
    continent: "Antarctica",
    continentCode: "an",
    latitude: "-54.4201305",
    linkedinHeadline: "Bouvet Island",
    linkedinId: "102127336",
    longitude: "3.3599732952297483",
    name: {
      en: "Bouvet Island",
      es: "Isla Bouvet",
      fr: "\xCEle Bouvet",
      native: ["Bouvet\xF8ya"]
    },
    population: 0
  },
  {
    code: "bw",
    continent: "Africa",
    continentCode: "af",
    latitude: "-23.1681782",
    linkedinHeadline: "Botswana",
    linkedinId: "105698121",
    longitude: "24.5928742",
    name: {
      en: "Botswana",
      es: "Botswana",
      fr: "Botswana",
      native: ["Botswana"]
    },
    population: 2385e3
  },
  {
    code: "by",
    continent: "Europe",
    continentCode: "eu",
    latitude: "53.4250605",
    linkedinHeadline: "Belarus",
    linkedinId: "101705918",
    longitude: "27.6971358",
    name: {
      en: "Belarus",
      es: "Bielorrusia",
      fr: "Bi\xE9lorussie",
      native: ["\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C"]
    },
    population: 944e4
  },
  {
    code: "bz",
    continent: "North America",
    continentCode: "na",
    latitude: "16.8259793",
    linkedinHeadline: "Belize",
    linkedinId: "105912732",
    longitude: "-88.7600927",
    name: {
      en: "Belize",
      es: "Belice",
      fr: "Belize",
      native: ["Belize"]
    },
    population: 398e3
  },
  {
    code: "ca",
    continent: "North America",
    continentCode: "na",
    latitude: "61.0666922",
    linkedinHeadline: "Canada",
    linkedinId: "101174742",
    longitude: "-107.9917071",
    name: {
      en: "Canada",
      es: "Canad\xE1",
      fr: "Canada",
      native: ["Canada"]
    },
    population: 38023e3
  },
  {
    code: "cc",
    continent: "Asia",
    continentCode: "as",
    latitude: "-12.0728315",
    linkedinHeadline: "Cocos (Keeling) Islands",
    linkedinId: "103188119",
    longitude: "96.8409375",
    name: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos (Keeling)",
      fr: "\xCEles Cocos (Keeling)",
      native: ["Cocos (Keeling) Islands"]
    },
    population: 500
  },
  {
    code: "cd",
    continent: "Africa",
    continentCode: "af",
    latitude: "-2.9814344",
    linkedinHeadline: "Congo (DRC)",
    linkedinId: "101271829",
    longitude: "23.8222636",
    name: {
      en: "Democratic Republic of the Congo",
      es: "Rep\xFAblica Democr\xE1tica del Congo",
      fr: "R\xE9publique D\xE9mocratique du Congo",
      native: ["R\xE9publique D\xE9mocratique du Congo"]
    },
    population: 92378e3
  },
  {
    code: "cf",
    continent: "Africa",
    continentCode: "af",
    latitude: "7.0323598",
    linkedinHeadline: "Central African Republic",
    linkedinId: "100134827",
    longitude: "19.9981227",
    name: {
      en: "Central African Republic",
      es: "Rep\xFAblica Centroafricana",
      fr: "R\xE9publique centrafricaine",
      native: ["R\xE9publique centrafricaine"]
    },
    population: 4918e3
  },
  {
    code: "cg",
    continent: "Africa",
    continentCode: "af",
    latitude: "-0.7264327",
    linkedinHeadline: "Republic of the Congo",
    linkedinId: "106796687",
    longitude: "15.6419155",
    name: {
      en: "Republic of the Congo",
      es: "Rep\xFAblica del congo",
      fr: "R\xE9publique du Congo",
      native: ["R\xE9publique du Congo"]
    },
    population: 5543e3
  },
  {
    code: "ch",
    continent: "Europe",
    continentCode: "eu",
    latitude: "46.7985624",
    linkedinHeadline: "Switzerland",
    linkedinId: "106693272",
    longitude: "8.2319736",
    name: {
      en: "Switzerland",
      es: "Suiza",
      fr: "Suisse",
      native: ["Schweiz", "Suisse"]
    },
    population: 8692e3
  },
  {
    code: "ci",
    continent: "Africa",
    continentCode: "af",
    latitude: "7.9897371",
    linkedinHeadline: "C\xF4te d'Ivoire",
    linkedinId: "103295271",
    longitude: "-5.5679458",
    name: {
      en: "C\xF4te d'Ivoire",
      es: "Costa de Marfil",
      fr: "C\xF4te d'Ivoire",
      native: ["C\xF4te d'Ivoire"]
    },
    population: 28873034
  },
  {
    code: "ck",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-16.0492781",
    linkedinHeadline: "Cook Islands",
    linkedinId: "103118752",
    longitude: "-160.3554851",
    name: {
      en: "Cook Islands",
      es: "Islas Cook",
      fr: "\xCEles Cook",
      native: ["K\u016Bki '\u0100irani"]
    },
    population: 18e3
  },
  {
    code: "cl",
    continent: "South America",
    continentCode: "sa",
    latitude: "-31.7613365",
    linkedinHeadline: "Chile",
    linkedinId: "104621616",
    longitude: "-71.3187697",
    name: {
      en: "Chile",
      es: "Chile",
      fr: "Chili",
      native: ["Chile"]
    },
    population: 19177e3
  },
  {
    code: "cm",
    continent: "Africa",
    continentCode: "af",
    latitude: "4.6125522",
    linkedinHeadline: "Cameroon",
    linkedinId: "105745966",
    longitude: "13.1535811",
    name: {
      en: "Cameroon",
      es: "Camer\xFAn",
      fr: "Cameroun",
      native: ["Cameroun"]
    },
    population: 27331e3
  },
  {
    code: "cn",
    continent: "Asia",
    continentCode: "as",
    latitude: "35.000074",
    linkedinHeadline: "China",
    linkedinId: "102890883",
    longitude: "104.999927",
    name: {
      en: "China",
      es: "China",
      fr: "Chine",
      native: ["\u4E2D\u56FD"]
    },
    population: 144421e4
  },
  {
    code: "co",
    continent: "South America",
    continentCode: "sa",
    latitude: "2.8894434",
    linkedinHeadline: "Colombia",
    linkedinId: "100876405",
    longitude: "-73.783892",
    name: {
      en: "Colombia",
      es: "Colombia",
      fr: "Colombie",
      native: ["Colombia"]
    },
    population: 51146e3
  },
  {
    code: "cr",
    continent: "North America",
    continentCode: "na",
    latitude: "10.2735633",
    linkedinHeadline: "Costa Rica",
    linkedinId: "101739942",
    longitude: "-84.0739102",
    name: {
      en: "Costa Rica",
      es: "Costa Rica",
      fr: "Costa Rica",
      native: ["Costa Rica"]
    },
    population: 5131e3
  },
  {
    code: "cu",
    continent: "North America",
    continentCode: "na",
    latitude: "23.0131338",
    linkedinHeadline: "Cuba",
    linkedinId: "106429766",
    longitude: "-80.8328748",
    name: {
      en: "Cuba",
      es: "Cuba",
      fr: "Cuba",
      native: ["Cuba"]
    },
    population: 11328e3
  },
  {
    code: "cv",
    continent: "Africa",
    continentCode: "af",
    latitude: "16.0000552",
    linkedinHeadline: "Cape Verde",
    linkedinId: "101679268",
    longitude: "-24.0083947",
    name: {
      en: "Cape Verde",
      es: "Cabo Verde",
      fr: "Cap-Vert",
      native: ["Cabo Verde"]
    },
    population: 556e3
  },
  {
    code: "cw",
    continent: "South America",
    continentCode: "sa",
    latitude: "12.1845",
    linkedinHeadline: "Cura\xE7ao",
    linkedinId: "103619688",
    longitude: "-68.9640875031406",
    name: {
      en: "Cura\xE7ao",
      es: "Curazao",
      fr: "Curacao",
      native: ["Cura\xE7ao"]
    },
    population: 164e3
  },
  {
    code: "cx",
    continent: "Asia",
    continentCode: "as",
    latitude: "-10.49124145",
    linkedinHeadline: "Christmas Island",
    linkedinId: "102893931",
    longitude: "105.6173514897963",
    name: {
      en: "Christmas Island",
      es: "Isla de Navidad",
      fr: "L'\xEEle de no\xEBl",
      native: ["Christmas Island"]
    },
    population: 2e3
  },
  {
    code: "cy",
    continent: "Europe",
    continentCode: "eu",
    latitude: "34.9823018",
    linkedinHeadline: "Cyprus",
    linkedinId: "106774002",
    longitude: "33.1451285",
    name: {
      en: "Cyprus",
      es: "Chipre",
      fr: "Chypre",
      native: ["\u039A\u03CD\u03C0\u03C1\u03BF\u03C2", "K\u0131br\u0131s"]
    },
    population: 1207e3
  },
  {
    code: "cz",
    continent: "Europe",
    continentCode: "eu",
    latitude: "49.8167003",
    linkedinHeadline: "Czechia",
    linkedinId: "104508036",
    longitude: "15.4749544",
    name: {
      en: "Czechia",
      es: "Republica Checa",
      fr: "R\xE9publique Tch\xE8que",
      native: ["\u010Cesko"]
    },
    population: 10724e3
  },
  {
    code: "de",
    continent: "Europe",
    continentCode: "eu",
    latitude: "51.0834196",
    linkedinHeadline: "Germany",
    linkedinId: "101282230",
    longitude: "10.4234469",
    name: {
      en: "Germany",
      es: "Alemania",
      fr: "Allemagne",
      native: ["Deutschland"]
    },
    population: 83124e3
  },
  {
    code: "dj",
    continent: "Africa",
    continentCode: "af",
    latitude: "11.8145966",
    linkedinHeadline: "Djibouti",
    linkedinId: "100371290",
    longitude: "42.8453061",
    name: {
      en: "Djibouti",
      es: "Djibouti",
      fr: "Djibouti",
      native: ["Djibouti", "\u062C\u064A\u0628\u0648\u062A\u064A"]
    },
    population: 993e3
  },
  {
    code: "dk",
    continent: "Europe",
    continentCode: "eu",
    latitude: "55.670249",
    linkedinHeadline: "Denmark",
    linkedinId: "104514075",
    longitude: "10.3333283",
    name: {
      en: "Denmark",
      es: "Dinamarca",
      fr: "Danemark",
      native: ["Danmark"]
    },
    population: 5814e3
  },
  {
    code: "dm",
    continent: "North America",
    continentCode: "na",
    latitude: "19.0974031",
    linkedinHeadline: "Dominica",
    linkedinId: "100720695",
    longitude: "-70.3028026",
    name: {
      en: "Dominica",
      es: "Dominica",
      fr: "Dominique",
      native: ["Dominica"]
    },
    population: 72e3
  },
  {
    code: "do",
    continent: "North America",
    continentCode: "na",
    latitude: "19.0974031",
    linkedinHeadline: "Dominican Republic",
    linkedinId: "105057336",
    longitude: "-70.3028026",
    name: {
      en: "Dominican Republic",
      es: "Rep\xFAblica Dominicana",
      fr: "R\xE9publique dominicaine",
      native: ["Rep\xFAblica Dominicana"]
    },
    population: 10927e3
  },
  {
    code: "dz",
    continent: "Africa",
    continentCode: "af",
    latitude: "28.0000272",
    linkedinHeadline: "Algeria",
    linkedinId: "106395874",
    longitude: "2.9999825",
    name: {
      en: "Algeria",
      es: "Argelia",
      fr: "Alg\xE9rie",
      native: ["\u0627\u0644\u062C\u0632\u0627\u0626\u0631"]
    },
    population: 44661e3
  },
  {
    code: "ec",
    continent: "South America",
    continentCode: "sa",
    latitude: "-1.3397668",
    linkedinHeadline: "Ecuador",
    linkedinId: "106373116",
    longitude: "-79.3666965",
    name: {
      en: "Ecuador",
      es: "Ecuador",
      fr: "Equateur",
      native: ["Ecuador"]
    },
    population: 17819e3
  },
  {
    code: "ee",
    continent: "Europe",
    continentCode: "eu",
    latitude: "58.7523778",
    linkedinHeadline: "Estonia",
    linkedinId: "102974008",
    longitude: "25.3319078",
    name: {
      en: "Estonia",
      es: "Estonia",
      fr: "Estonie",
      native: ["Eesti"]
    },
    population: 1327e3
  },
  {
    code: "eg",
    continent: "Africa",
    continentCode: "af",
    latitude: "26.2540493",
    linkedinHeadline: "Egypt",
    linkedinId: "106155005",
    longitude: "29.2675469",
    name: {
      en: "Egypt",
      es: "Egipto",
      fr: "Egypte",
      native: ["\u0645\u0635\u0631"]
    },
    population: 104124e3
  },
  {
    code: "eh",
    continent: "Africa",
    continentCode: "af",
    latitude: "24.1797324",
    linkedinHeadline: "Western Sahara, Morocco",
    linkedinId: "115461347",
    longitude: "-13.7667848",
    name: {
      en: "Western Sahara",
      es: "Sahara Occidental",
      fr: "Sahara occidental",
      native: ["\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629"]
    },
    population: 609e3
  },
  {
    code: "er",
    continent: "Africa",
    continentCode: "af",
    latitude: "15.9500319",
    linkedinHeadline: "Eritrea",
    linkedinId: "104219996",
    longitude: "37.9999668",
    name: {
      en: "Eritrea",
      es: "Eritrea",
      fr: "\xC9rythr\xE9e",
      native: ["\u12A4\u122D\u1275\u122B"]
    },
    population: 3628e3
  },
  {
    code: "es",
    continent: "Europe",
    continentCode: "eu",
    latitude: "39.3262345",
    linkedinHeadline: "Spain",
    linkedinId: "105646813",
    longitude: "-4.8380649",
    name: {
      en: "Spain",
      es: "Espa\xF1a",
      fr: "Espagne",
      native: ["Espa\xF1a"]
    },
    population: 46755e3
  },
  {
    code: "et",
    continent: "Africa",
    continentCode: "af",
    latitude: "10.2116702",
    linkedinHeadline: "Ethiopia",
    linkedinId: "100212432",
    longitude: "38.6521203",
    name: {
      en: "Ethiopia",
      es: "Etiop\xEDa",
      fr: "Ethiopie",
      native: ["\u12A2\u1275\u12EE\u1335\u12EB"]
    },
    population: 118063e3
  },
  {
    code: "fi",
    continent: "Europe",
    continentCode: "eu",
    latitude: "63.2467777",
    linkedinHeadline: "Finland",
    linkedinId: "100456013",
    longitude: "25.9209164",
    name: {
      en: "Finland",
      es: "Finlandia",
      fr: "Finlande",
      native: ["Suomi"]
    },
    population: 5543e3
  },
  {
    code: "fj",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-18.1239696",
    linkedinHeadline: "Fiji",
    linkedinId: "105733447",
    longitude: "179.0122737",
    name: {
      en: "Fiji",
      es: "Fiyi",
      fr: "Fidji",
      native: ["Viti"]
    },
    population: 901e3
  },
  {
    code: "fk",
    continent: "South America",
    continentCode: "sa",
    latitude: "-51.9666424",
    linkedinHeadline: "Falkland Islands",
    linkedinId: "104961595",
    longitude: "-59.5500387",
    name: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      fr: "\xCEles Falkland",
      native: ["Islas Malvinas"]
    },
    population: 3e3
  },
  {
    code: "fm",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "7",
    linkedinHeadline: "Federated States of Micronesia",
    linkedinId: "102762290",
    longitude: "155.25",
    name: {
      en: "Federated States of Micronesia",
      es: "Estados Federados de Micronesia",
      fr: "\xC9tats f\xE9d\xE9r\xE9s de Micron\xE9sie",
      native: ["Micronesia"]
    },
    population: 104e3
  },
  {
    code: "fo",
    continent: "Europe",
    continentCode: "eu",
    latitude: "62.19850045",
    linkedinHeadline: "Faroe Islands",
    linkedinId: "104630756",
    longitude: "-6.817412433412175",
    name: {
      en: "Faroe Islands",
      es: "Islas Faroe",
      fr: "\xCEles F\xE9ro\xE9",
      native: ["F\xF8royar"]
    },
    population: 49e3
  },
  {
    code: "fr",
    continent: "Europe",
    continentCode: "eu",
    latitude: "46.603354",
    linkedinHeadline: "France",
    linkedinId: "105015875",
    longitude: "1.8883335",
    name: {
      en: "France",
      es: "Francia",
      fr: "France",
      native: ["France"]
    },
    population: 65426e3
  },
  {
    code: "ga",
    continent: "Africa",
    continentCode: "af",
    latitude: "-0.8999695",
    linkedinHeadline: "Gabon",
    linkedinId: "104471338",
    longitude: "11.6899699",
    name: {
      en: "Gabon",
      es: "Gab\xF3n",
      fr: "Gabon",
      native: ["Gabon"]
    },
    population: 2278e3
  },
  {
    code: "gb",
    continent: "Europe",
    continentCode: "eu",
    latitude: "54.7023545",
    linkedinHeadline: "United Kingdom",
    linkedinId: "101165590",
    longitude: "-3.2765753",
    name: {
      en: "United Kingdom",
      es: "Reino Unido",
      fr: "Royaume-Uni",
      native: ["United Kingdom"]
    },
    population: 68086e3
  },
  {
    code: "gd",
    continent: "North America",
    continentCode: "na",
    latitude: "12.1360374",
    linkedinHeadline: "Grenada",
    linkedinId: "104579260",
    longitude: "-61.6904045",
    name: {
      en: "Grenada",
      es: "Granada",
      fr: "Grenade",
      native: ["Grenada"]
    },
    population: 113e3
  },
  {
    code: "ge",
    continent: "Asia",
    continentCode: "as",
    latitude: "41.6809707",
    linkedinHeadline: "Georgia",
    linkedinId: "106315325",
    longitude: "44.0287382",
    name: {
      en: "Georgia",
      es: "Georgia",
      fr: "G\xE9orgie",
      native: ["\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD"]
    },
    population: 3986e3
  },
  {
    code: "gf",
    continent: "South America",
    continentCode: "sa",
    latitude: "4.0039882",
    linkedinHeadline: "French Guiana",
    linkedinId: "105001561",
    longitude: "-52.999998",
    name: {
      en: "French Guiana",
      es: "Guayana Francesa",
      fr: "Guyane Fran\xE7aise",
      native: ["Guyane"]
    },
    population: 306e3
  },
  {
    code: "gg",
    continent: "Europe",
    continentCode: "eu",
    latitude: "49.580437",
    linkedinHeadline: "Guernsey",
    linkedinId: "104019891",
    longitude: "-2.484854",
    name: {
      en: "Guernsey",
      es: "Guernsey",
      fr: "Guernesey",
      native: ["Guernsey"]
    },
    population: 67e3
  },
  {
    code: "gh",
    continent: "Africa",
    continentCode: "af",
    latitude: "8.0300284",
    linkedinHeadline: "Ghana",
    linkedinId: "105769538",
    longitude: "-1.0800271",
    name: {
      en: "Ghana",
      es: "Ghana",
      fr: "Ghana",
      native: ["Ghana"]
    },
    population: 31732e3
  },
  {
    code: "gi",
    continent: "Europe",
    continentCode: "eu",
    latitude: "36.140807",
    linkedinHeadline: "Gibraltar",
    linkedinId: "100674501",
    longitude: "-5.3541295",
    name: {
      en: "Gibraltar",
      es: "Gibraltar",
      fr: "Gibraltar",
      native: ["Gibraltar"]
    },
    population: 34e3
  },
  {
    code: "gl",
    continent: "North America",
    continentCode: "na",
    latitude: "77.6192349",
    linkedinHeadline: "Greenland",
    linkedinId: "103705642",
    longitude: "-42.8125967",
    name: {
      en: "Greenland",
      es: "Groenlandia",
      fr: "Groenland",
      native: ["Kalaallit Nunaat"]
    },
    population: 57e3
  },
  {
    code: "gm",
    continent: "Africa",
    continentCode: "af",
    latitude: "13.470062",
    linkedinHeadline: "The Gambia",
    linkedinId: "106100033",
    longitude: "-15.4900464",
    name: {
      en: "The Gambia",
      es: "Gambia",
      fr: "Gambie",
      native: ["Gambia"]
    },
    population: 2451e3
  },
  {
    code: "gn",
    continent: "Africa",
    continentCode: "af",
    latitude: "10.7226226",
    linkedinHeadline: "Guinea",
    linkedinId: "100099594",
    longitude: "-10.7083587",
    name: {
      en: "Guinea",
      es: "Guinea",
      fr: "Guin\xE9e",
      native: ["Guin\xE9e"]
    },
    population: 13369e3
  },
  {
    code: "gp",
    continent: "North America",
    continentCode: "na",
    latitude: "16.2490067",
    linkedinHeadline: "Guadeloupe",
    linkedinId: "104232339",
    longitude: "-61.5650444",
    name: {
      en: "Guadeloupe",
      es: "Guadalupe",
      fr: "Guadeloupe",
      native: ["Guadeloupe"]
    },
    population: 4e5
  },
  {
    code: "gq",
    continent: "Africa",
    continentCode: "af",
    latitude: "1.613172",
    linkedinHeadline: "Equatorial Guinea",
    linkedinId: "105141335",
    longitude: "10.5170357",
    name: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      fr: "Guin\xE9e \xC9quatoriale",
      native: ["Guinea Ecuatorial"]
    },
    population: 1436e3
  },
  {
    code: "gr",
    continent: "Europe",
    continentCode: "eu",
    latitude: "38.9953683",
    linkedinHeadline: "Greece",
    linkedinId: "104677530",
    longitude: "21.9877132",
    name: {
      en: "Greece",
      es: "Grecia",
      fr: "Gr\xE8ce",
      native: ["\u0395\u03BB\u03BB\u03AC\u03B4\u03B1"]
    },
    population: 10423e3
  },
  {
    code: "gs",
    continent: "Antarctica",
    continentCode: "an",
    latitude: "-54.8432857",
    linkedinHeadline: "South Georgia and the South Sandwich Islands",
    linkedinId: "103665423",
    longitude: "-35.8090698",
    name: {
      en: "South Georgia and the South Sandwich Islands",
      es: "Georgia del sur y las islas Sandwich del sur",
      fr: "G\xE9orgie du Sud et \xEEles Sandwich du Sud",
      native: ["South Georgia and the South Sandwich Islands"]
    },
    population: 0
  },
  {
    code: "gt",
    continent: "North America",
    continentCode: "na",
    latitude: "15.6356088",
    linkedinHeadline: "Guatemala",
    linkedinId: "100877388",
    longitude: "-89.8988087",
    name: {
      en: "Guatemala",
      es: "Guatemala",
      fr: "Guatemala",
      native: ["Guatemala"]
    },
    population: 18132e3
  },
  {
    code: "gu",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "13.450125700000001",
    linkedinHeadline: "Guam",
    linkedinId: "107006862",
    longitude: "144.75755102972062",
    name: {
      en: "Guam",
      es: "Guam",
      fr: "Guam",
      native: ["Gu\xE5h\xE5n"]
    },
    population: 169e3
  },
  {
    code: "gw",
    continent: "Africa",
    continentCode: "af",
    latitude: "12.100035",
    linkedinHeadline: "Guinea-Bissau",
    linkedinId: "100115557",
    longitude: "-14.9000214",
    name: {
      en: "Guinea-Bissau",
      es: "Guinea-Bis\xE1u",
      fr: "Guin\xE9e-Bissau",
      native: ["Guin\xE9-Bissau"]
    },
    population: 2015e3
  },
  {
    code: "gy",
    continent: "South America",
    continentCode: "sa",
    latitude: "4.8417097",
    linkedinHeadline: "Guyana",
    linkedinId: "105836293",
    longitude: "-58.6416891",
    name: {
      en: "Guyana",
      es: "Guayana",
      fr: "Guyane",
      native: ["Guyana"]
    },
    population: 787e3
  },
  {
    code: "hk",
    continent: "Asia",
    continentCode: "as",
    latitude: "22.2793278",
    linkedinHeadline: "Hong Kong  SAR",
    linkedinId: "103291313",
    longitude: "114.1628131",
    name: {
      en: "Hong Kong",
      es: "Hong Kong",
      fr: "Hong Kong",
      native: ["\u9999\u6E2F"]
    },
    population: 7554e3
  },
  {
    code: "hm",
    continent: "Antarctica",
    continentCode: "an",
    latitude: "-53.0166353",
    linkedinHeadline: "Heard Island and McDonald Islands",
    linkedinId: "100737582",
    longitude: "72.955751",
    name: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      fr: "\xCEles Heard et McDonald",
      native: ["Heard Island and McDonald Islands"]
    },
    population: 0
  },
  {
    code: "hn",
    continent: "North America",
    continentCode: "na",
    latitude: "15.2572432",
    linkedinHeadline: "Honduras",
    linkedinId: "101937718",
    longitude: "-86.0755145",
    name: {
      en: "Honduras",
      es: "Honduras",
      fr: "Honduras",
      native: ["Honduras"]
    },
    population: 10271e3
  },
  {
    code: "hr",
    continent: "Europe",
    continentCode: "eu",
    latitude: "45.5643442",
    linkedinHeadline: "Croatia",
    linkedinId: "104688944",
    longitude: "17.0118954",
    name: {
      en: "Croatia",
      es: "Croacia",
      fr: "Croatie",
      native: ["Hrvatska"]
    },
    population: 4052e3
  },
  {
    code: "ht",
    continent: "North America",
    continentCode: "na",
    latitude: "19.1399952",
    linkedinHeadline: "Haiti",
    linkedinId: "100993490",
    longitude: "-72.3570972",
    name: {
      en: "Haiti",
      es: "Hait\xED",
      fr: "Ha\xEFti",
      native: ["Ha\xEFti"]
    },
    population: 11536e3
  },
  {
    code: "hu",
    continent: "Europe",
    continentCode: "eu",
    latitude: "47.1817585",
    linkedinHeadline: "Hungary",
    linkedinId: "100288700",
    longitude: "19.5060937",
    name: {
      en: "Hungary",
      es: "Hungr\xEDa",
      fr: "Hongrie",
      native: ["Magyarorsz\xE1g"]
    },
    population: 9636e3
  },
  {
    code: "id",
    continent: "Asia",
    continentCode: "as",
    latitude: "-2.4833826",
    linkedinHeadline: "Indonesia",
    linkedinId: "102478259",
    longitude: "117.8902853",
    name: {
      en: "Indonesia",
      es: "Indonesia",
      fr: "Indon\xE9sie",
      native: ["Indonesia"]
    },
    population: 276361e3
  },
  {
    code: "ie",
    continent: "Europe",
    continentCode: "eu",
    latitude: "52.865196",
    linkedinHeadline: "Ireland",
    linkedinId: "104738515",
    longitude: "-7.9794599",
    name: {
      en: "Ireland",
      es: "Irlanda",
      fr: "Irlande",
      native: ["\xC9ire"]
    },
    population: 4991e3
  },
  {
    code: "il",
    continent: "Asia",
    continentCode: "as",
    latitude: "31.5313113",
    linkedinHeadline: "Israel",
    linkedinId: "101620260",
    longitude: "34.8667654",
    name: {
      en: "Israel",
      es: "Israel",
      fr: "Isra\xEBl",
      native: ["\u05D9\u05E9\u05E8\u05D0\u05DC"]
    },
    population: 9198e3
  },
  {
    code: "im",
    continent: "Europe",
    continentCode: "eu",
    latitude: "54.2358167",
    linkedinHeadline: "Isle of Man",
    linkedinId: "106316481",
    longitude: "-4.514598745698255",
    name: {
      en: "Isle of Man",
      es: "Isla del hombre",
      fr: "\xCEle de Man",
      native: ["Isle of Man"]
    },
    population: 85e3
  },
  {
    code: "in",
    continent: "Asia",
    continentCode: "as",
    latitude: "22.3511148",
    linkedinHeadline: "India",
    linkedinId: "102713980",
    longitude: "78.6677428",
    name: {
      en: "India",
      es: "India",
      fr: "Inde",
      native: ["\u092D\u093E\u0930\u0924"]
    },
    population: 1393409e3
  },
  {
    code: "io",
    continent: "Asia",
    continentCode: "as",
    latitude: "-6.4157192",
    linkedinHeadline: "British Indian Ocean Territory",
    linkedinId: "106498958",
    longitude: "72.1173961",
    name: {
      en: "British Indian Ocean Territory",
      es: "Territorio Brit\xE1nico del Oc\xE9ano \xCDndico",
      fr: "Territoire britannique de l'oc\xE9an Indien",
      native: ["British Indian Ocean Territory"]
    },
    population: 3e3
  },
  {
    code: "iq",
    continent: "Asia",
    continentCode: "as",
    latitude: "33.0955793",
    linkedinHeadline: "Iraq",
    linkedinId: "106725625",
    longitude: "44.1749775",
    name: {
      en: "Iraq",
      es: "Irak",
      fr: "Irak",
      native: ["\u0627\u0644\u0639\u0631\u0627\u0642"]
    },
    population: 40966e3
  },
  {
    code: "ir",
    continent: "Asia",
    continentCode: "as",
    latitude: "32.6475314",
    linkedinHeadline: "Iran",
    linkedinId: "101934083",
    longitude: "54.5643516",
    name: {
      en: "Iran",
      es: "Iran",
      fr: "Iran",
      native: ["\u0627\u06CC\u0631\u0627\u0646"]
    },
    population: 84539e3
  },
  {
    code: "is",
    continent: "Europe",
    continentCode: "eu",
    latitude: "64.9841821",
    linkedinHeadline: "Iceland",
    linkedinId: "105238872",
    longitude: "-18.1059013",
    name: {
      en: "Iceland",
      es: "Islandia",
      fr: "Islande",
      native: ["\xCDsland"]
    },
    population: 364e3
  },
  {
    code: "it",
    continent: "Europe",
    continentCode: "eu",
    latitude: "42.6384261",
    linkedinHeadline: "Italy",
    linkedinId: "103350119",
    longitude: "12.674297",
    name: {
      en: "Italy",
      es: "Italia",
      fr: "Italie",
      native: ["Italia"]
    },
    population: 60317e3
  },
  {
    code: "je",
    continent: "Europe",
    continentCode: "eu",
    latitude: "49.21230655",
    linkedinHeadline: "Jersey",
    linkedinId: "102705533",
    longitude: "-2.1255999596428845",
    name: {
      en: "Jersey",
      es: "Jersey",
      fr: "Jersey",
      native: ["Jersey"]
    },
    population: 101e3
  },
  {
    code: "jm",
    continent: "North America",
    continentCode: "na",
    latitude: "18.1152958",
    linkedinHeadline: "Jamaica",
    linkedinId: "105126983",
    longitude: "-77.1598454610168",
    name: {
      en: "Jamaica",
      es: "Jamaica",
      fr: "Jama\xEFque",
      native: ["Jamaica"]
    },
    population: 2973e3
  },
  {
    code: "jo",
    continent: "Asia",
    continentCode: "as",
    latitude: "31.1667049",
    linkedinHeadline: "Jordan",
    linkedinId: "103710677",
    longitude: "36.941628",
    name: {
      en: "Jordan",
      es: "Jord\xE1n",
      fr: "Jordan",
      native: ["\u0627\u0644\u0623\u0631\u062F\u0646"]
    },
    population: 10441e3
  },
  {
    code: "jp",
    continent: "Asia",
    continentCode: "as",
    latitude: "36.5748441",
    linkedinHeadline: "Japan",
    linkedinId: "101355337",
    longitude: "139.2394179",
    name: {
      en: "Japan",
      es: "Jap\xF3n",
      fr: "Japon",
      native: ["\u65E5\u672C"]
    },
    population: 12605e4
  },
  {
    code: "ke",
    continent: "Africa",
    continentCode: "af",
    latitude: "1.4419683",
    linkedinHeadline: "Kenya",
    linkedinId: "100710459",
    longitude: "38.4313975",
    name: {
      en: "Kenya",
      es: "Kenia",
      fr: "Kenya",
      native: ["Kenya"]
    },
    population: 54795e3
  },
  {
    code: "kg",
    continent: "Asia",
    continentCode: "as",
    latitude: "41.5089324",
    linkedinHeadline: "Kyrgyzstan",
    linkedinId: "103490790",
    longitude: "74.724091",
    name: {
      en: "Kyrgyzstan",
      es: "Kirguist\xE1n",
      fr: "Kirghizistan",
      native: ["\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D"]
    },
    population: 6632e3
  },
  {
    code: "kh",
    continent: "Asia",
    continentCode: "as",
    latitude: "13.5066394",
    linkedinHeadline: "Cambodia",
    linkedinId: "102500897",
    longitude: "104.869423",
    name: {
      en: "Cambodia",
      es: "Camboya",
      fr: "Cambodge",
      native: ["\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6"]
    },
    population: 16972e3
  },
  {
    code: "ki",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "0.306",
    linkedinHeadline: "Kiribati",
    linkedinId: "104742735",
    longitude: "173.664834025",
    name: {
      en: "Kiribati",
      es: "Kiribati",
      fr: "Kiribati",
      native: ["Kiribati"]
    },
    population: 119e3
  },
  {
    code: "km",
    continent: "Africa",
    continentCode: "af",
    latitude: "-12.2045176",
    linkedinHeadline: "Comoros",
    linkedinId: "103069791",
    longitude: "44.2832964",
    name: {
      en: "Comoros",
      es: "Comoras",
      fr: "Comores",
      native: ["Comores", "\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631"]
    },
    population: 888e3
  },
  {
    code: "kn",
    continent: "North America",
    continentCode: "na",
    latitude: "17.250512",
    linkedinHeadline: "Saint Kitts, St Kitts and Nevis",
    linkedinId: "102098694",
    longitude: "-62.6725973",
    name: {
      en: "Saint Kitts and Nevis",
      es: "Saint Kitts y Nevis",
      fr: "Saint-Christophe-et-Ni\xE9v\xE8s",
      native: ["Saint Kitts and Nevis"]
    },
    population: 53e3
  },
  {
    code: "kp",
    continent: "Asia",
    continentCode: "as",
    latitude: "40.3736611",
    linkedinHeadline: "North Korea",
    linkedinId: "102356536",
    longitude: "127.0870417",
    name: {
      en: "North Korea",
      es: "Corea del Norte",
      fr: "Cor\xE9e du Nord",
      native: ["\uC870\uC120"]
    },
    population: 25827e3
  },
  {
    code: "kr",
    continent: "Asia",
    continentCode: "as",
    latitude: "36.638392",
    linkedinHeadline: "South Korea",
    linkedinId: "105149562",
    longitude: "127.6961188",
    name: {
      en: "South Korea",
      es: "Corea del Sur",
      fr: "Cor\xE9e du Sud",
      native: ["\uB300\uD55C\uBBFC\uAD6D"]
    },
    population: 51781e3
  },
  {
    code: "kw",
    continent: "Asia",
    continentCode: "as",
    latitude: "29.2733964",
    linkedinHeadline: "Kuwait",
    linkedinId: "103239229",
    longitude: "47.4979476",
    name: {
      en: "Kuwait",
      es: "Kuwait",
      fr: "Koweit",
      native: ["\u0627\u0644\u0643\u0648\u064A\u062A"]
    },
    population: 427e4
  },
  {
    code: "ky",
    continent: "North America",
    continentCode: "na",
    latitude: "19.5417212",
    linkedinHeadline: "Cayman Islands",
    linkedinId: "101679506",
    longitude: "-80.5667132",
    name: {
      en: "Cayman Islands",
      es: "Islas Caim\xE1n",
      fr: "\xCEles Ca\xEFmans",
      native: ["Cayman Islands"]
    },
    population: 66e3
  },
  {
    code: "kz",
    continent: "Asia",
    continentCode: "as",
    latitude: "47.2286086",
    linkedinHeadline: "Kazakhstan",
    linkedinId: "106049128",
    longitude: "65.2093197",
    name: {
      en: "Kazakhstan",
      es: "Kazajst\xE1n",
      fr: "Kazakhstan",
      native: ["\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D"]
    },
    population: 18952e3
  },
  {
    code: "la",
    continent: "Asia",
    continentCode: "as",
    latitude: "20.0171109",
    linkedinHeadline: "Laos",
    linkedinId: "100664862",
    longitude: "103.378253",
    name: {
      en: "Laos",
      es: "Laos",
      fr: "Laos",
      native: ["\u0EA5\u0EB2\u0EA7"]
    },
    population: 7419e3
  },
  {
    code: "lb",
    continent: "Asia",
    continentCode: "as",
    latitude: "33.8750629",
    linkedinHeadline: "Lebanon",
    linkedinId: "101834488",
    longitude: "35.843409",
    name: {
      en: "Lebanon",
      es: "L\xEDbano",
      fr: "Liban",
      native: ["\u0644\u0628\u0646\u0627\u0646"]
    },
    population: 6813e3
  },
  {
    code: "lc",
    continent: "North America",
    continentCode: "na",
    latitude: "13.8250489",
    linkedinHeadline: "Saint Lucia",
    linkedinId: "104022923",
    longitude: "-60.975036",
    name: {
      en: "Saint Lucia",
      es: "Santa Luc\xEDa",
      fr: "Sainte-Lucie",
      native: ["Saint Lucia"]
    },
    population: 184e3
  },
  {
    code: "li",
    continent: "Europe",
    continentCode: "eu",
    latitude: "47.1416307",
    linkedinHeadline: "Liechtenstein",
    linkedinId: "100878084",
    longitude: "9.5531527",
    name: {
      en: "Liechtenstein",
      es: "Liechtenstein",
      fr: "Liechtenstein",
      native: ["Liechtenstein"]
    },
    population: 38e3
  },
  {
    code: "lk",
    continent: "Asia",
    continentCode: "as",
    latitude: "7.5554942",
    linkedinHeadline: "Sri Lanka",
    linkedinId: "100446352",
    longitude: "80.7137847",
    name: {
      en: "Sri Lanka",
      es: "Sri Lanka",
      fr: "Sri Lanka",
      native: ["\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0"]
    },
    population: 21444e3
  },
  {
    code: "lr",
    continent: "Africa",
    continentCode: "af",
    latitude: "5.7499721",
    linkedinHeadline: "Liberia",
    linkedinId: "106579411",
    longitude: "-9.3658524",
    name: {
      en: "Liberia",
      es: "Liberia",
      fr: "Lib\xE9ria",
      native: ["Liberia"]
    },
    population: 5184e3
  },
  {
    code: "ls",
    continent: "Africa",
    continentCode: "af",
    latitude: "-29.6039267",
    linkedinHeadline: "Lesotho",
    linkedinId: "103712797",
    longitude: "28.3350193",
    name: {
      en: "Lesotho",
      es: "Lesoto",
      fr: "Lesotho",
      native: ["Lesotho"]
    },
    population: 216e4
  },
  {
    code: "lt",
    continent: "Europe",
    continentCode: "eu",
    latitude: "55.3500003",
    linkedinHeadline: "Lithuania",
    linkedinId: "101464403",
    longitude: "23.7499997",
    name: {
      en: "Lithuania",
      es: "Lituania",
      fr: "Lituanie",
      native: ["Lietuva"]
    },
    population: 2683e3
  },
  {
    code: "lu",
    continent: "Europe",
    continentCode: "eu",
    latitude: "49.8158683",
    linkedinHeadline: "Luxembourg",
    linkedinId: "104042105",
    longitude: "6.1296751",
    name: {
      en: "Luxembourg",
      es: "Luxemburgo",
      fr: "Luxembourg",
      native: ["Luxembourg", "L\xEBtzebuerg"]
    },
    population: 635e3
  },
  {
    code: "lv",
    continent: "Europe",
    continentCode: "eu",
    latitude: "56.8406494",
    linkedinHeadline: "Latvia",
    linkedinId: "104341318",
    longitude: "24.7537645",
    name: {
      en: "Latvia",
      es: "Letonia",
      fr: "Lettonie",
      native: ["Latvija"]
    },
    population: 188e4
  },
  {
    code: "ly",
    continent: "Africa",
    continentCode: "af",
    latitude: "26.8234472",
    linkedinHeadline: "Libya",
    linkedinId: "104036859",
    longitude: "18.1236723",
    name: {
      en: "Libya",
      es: "Libia",
      fr: "Libye",
      native: ["\u0644\u064A\u0628\u064A\u0627"]
    },
    population: 6981e3
  },
  {
    code: "ma",
    continent: "Africa",
    continentCode: "af",
    latitude: "31.1728205",
    linkedinHeadline: "Morocco",
    linkedinId: "102787409",
    longitude: "-7.3362482",
    name: {
      en: "Morocco",
      es: "Marruecos",
      fr: "Maroc",
      native: ["\u0627\u0644\u0645\u063A\u0631\u0628"]
    },
    population: 37063e3
  },
  {
    code: "mc",
    continent: "Europe",
    continentCode: "eu",
    latitude: "43.73844905",
    linkedinHeadline: "Monaco",
    linkedinId: "101352147",
    longitude: "7.424224092532953",
    name: {
      en: "Monaco",
      es: "M\xF3naco",
      fr: "Monaco",
      native: ["Monaco"]
    },
    population: 39e3
  },
  {
    code: "md",
    continent: "Europe",
    continentCode: "eu",
    latitude: "47.2879608",
    linkedinHeadline: "Moldova",
    linkedinId: "106178099",
    longitude: "28.5670941",
    name: {
      en: "Moldova",
      es: "Moldavia",
      fr: "Moldavie",
      native: ["Moldova"]
    },
    population: 4026e3
  },
  {
    code: "me",
    continent: "Europe",
    continentCode: "eu",
    latitude: "42.9868853",
    linkedinHeadline: "Montenegro",
    linkedinId: "100733275",
    longitude: "19.5180992",
    name: {
      en: "Montenegro",
      es: "Montenegro",
      fr: "Mont\xE9n\xE9gro",
      native: ["Crna Gora", "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430"]
    },
    population: 622e3
  },
  {
    code: "mf",
    continent: "North America",
    continentCode: "na",
    latitude: "18.085493",
    linkedinHeadline: "Saint Martin, Guernsey, Guernsey",
    linkedinId: "103917985",
    longitude: "-63.05129209796061",
    name: {
      en: "Saint Martin (French Part)",
      es: "San Mart\xEDn (Parte Francesa)",
      fr: "Saint Martin (Partie Fran\xE7aise)",
      native: ["Saint-Martin"]
    },
    population: 39e3
  },
  {
    code: "mg",
    continent: "Africa",
    continentCode: "af",
    latitude: "-18.9249604",
    linkedinHeadline: "Madagascar",
    linkedinId: "105587166",
    longitude: "46.4416422",
    name: {
      en: "Madagascar",
      es: "Madagascar",
      fr: "Madagascar",
      native: ["Madagasikara"]
    },
    population: 28262e3
  },
  {
    code: "mh",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "6.9518742",
    linkedinHeadline: "Marshall Islands",
    linkedinId: "106516799",
    longitude: "170.9985095",
    name: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      fr: "Iles Marshall",
      native: ["M\u0327aje\u013C"]
    },
    population: 59e3
  },
  {
    code: "mk",
    continent: "Europe",
    continentCode: "eu",
    latitude: "41.6171214",
    linkedinHeadline: "North Macedonia",
    linkedinId: "103420483",
    longitude: "21.7168387",
    name: {
      en: "North Macedonia",
      es: "Macedonia del Norte",
      fr: "Mac\xE9doine du Nord",
      native: ["\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430"]
    },
    population: 2085e3
  },
  {
    code: "ml",
    continent: "Africa",
    continentCode: "af",
    latitude: "16.3700359",
    linkedinHeadline: "Mali",
    linkedinId: "100770782",
    longitude: "-2.2900239",
    name: {
      en: "Mali",
      es: "Mali",
      fr: "Mali",
      native: ["Mali"]
    },
    population: 20919e3
  },
  {
    code: "mm",
    continent: "Asia",
    continentCode: "as",
    latitude: "17.1750495",
    linkedinHeadline: "Myanmar",
    linkedinId: "104136533",
    longitude: "95.9999652",
    name: {
      en: "Myanmar",
      es: "Myanmar",
      fr: "Myanmar",
      native: ["\u1019\u103C\u1014\u103A\u1019\u102C"]
    },
    population: 54541e3
  },
  {
    code: "mn",
    continent: "Asia",
    continentCode: "as",
    latitude: "46.8250388",
    linkedinHeadline: "Mongolia",
    linkedinId: "102396337",
    longitude: "103.8499736",
    name: {
      en: "Mongolia",
      es: "Mongolia",
      fr: "Mongolie",
      native: ["\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441"]
    },
    population: 3345e3
  },
  {
    code: "mo",
    continent: "Asia",
    continentCode: "as",
    latitude: "22.1757605",
    linkedinHeadline: "Macao",
    linkedinId: "101316508",
    longitude: "113.5514142",
    name: {
      en: "Macao",
      es: "Macao",
      fr: "Macao",
      native: ["\u6FB3\u9580", "\u6FB3\u95E8"]
    },
    population: 658e3
  },
  {
    code: "mp",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "14.149020499999999",
    linkedinHeadline: "Northern Mariana Islands",
    linkedinId: "103666514",
    longitude: "145.21345248318923",
    name: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      fr: "\xCEles Mariannes du Nord",
      native: ["Sankattan Siha Na Islas Mari\xE5nas"]
    },
    population: 56e3
  },
  {
    code: "mq",
    continent: "North America",
    continentCode: "na",
    latitude: "14.6367927",
    linkedinHeadline: "French-Martinique",
    linkedinId: "103091690",
    longitude: "-61.01582685063731",
    name: {
      en: "Martinique",
      es: "Martinica",
      fr: "Martinique",
      native: ["Martinique"]
    },
    population: 374e3
  },
  {
    code: "mr",
    continent: "Africa",
    continentCode: "af",
    latitude: "20.2540382",
    linkedinHeadline: "Mauritania",
    linkedinId: "106950838",
    longitude: "-9.2399263",
    name: {
      en: "Mauritania",
      es: "Mauritania",
      fr: "Mauritanie",
      native: ["\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627"]
    },
    population: 4732e3
  },
  {
    code: "ms",
    continent: "North America",
    continentCode: "na",
    latitude: "16.7417041",
    linkedinHeadline: "Montserrat",
    linkedinId: "101150476",
    longitude: "-62.1916844",
    name: {
      en: "Montserrat",
      es: "Montserrat",
      fr: "Montserrat",
      native: ["Montserrat"]
    },
    population: 5e3
  },
  {
    code: "mt",
    continent: "Europe",
    continentCode: "eu",
    latitude: "35.8885993",
    linkedinHeadline: "Malta",
    linkedinId: "100961908",
    longitude: "14.4476911",
    name: {
      en: "Malta",
      es: "Malta",
      fr: "Malte",
      native: ["Malta"]
    },
    population: 442e3
  },
  {
    code: "mu",
    continent: "Africa",
    continentCode: "af",
    latitude: "-20.2759451",
    linkedinHeadline: "Mauritius",
    linkedinId: "106931611",
    longitude: "57.5703566",
    name: {
      en: "Mauritius",
      es: "Mauricio",
      fr: "\xCEle Maurice",
      native: ["Maurice"]
    },
    population: 1269e3
  },
  {
    code: "mv",
    continent: "Asia",
    continentCode: "as",
    latitude: "4.7064352",
    linkedinHeadline: "Maldives",
    linkedinId: "102161637",
    longitude: "73.3287853",
    name: {
      en: "Maldives",
      es: "Maldivas",
      fr: "Maldives",
      native: ["\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0783\u07A7\u0787\u07B0\u0796\u07AD\u078E\u07AC"]
    },
    population: 543e3
  },
  {
    code: "mw",
    continent: "Africa",
    continentCode: "af",
    latitude: "-13.2687204",
    linkedinHeadline: "Malawi",
    linkedinId: "105992277",
    longitude: "33.9301963",
    name: {
      en: "Malawi",
      es: "Malawi",
      fr: "Malawi",
      native: ["Malawi"]
    },
    population: 19498e3
  },
  {
    code: "mx",
    continent: "North America",
    continentCode: "na",
    latitude: "19.4326296",
    linkedinHeadline: "Mexico",
    linkedinId: "103323778",
    longitude: "-99.1331785",
    name: {
      en: "Mexico",
      es: "M\xE9xico",
      fr: "Mexique",
      native: ["M\xE9xico"]
    },
    population: 130262e3
  },
  {
    code: "my",
    continent: "Asia",
    continentCode: "as",
    latitude: "4.5693754",
    linkedinHeadline: "Malaysia",
    linkedinId: "106808692",
    longitude: "102.2656823",
    name: {
      en: "Malaysia",
      es: "Malasia",
      fr: "Malaisie",
      native: ["Malysia"]
    },
    population: 32776e3
  },
  {
    code: "mz",
    continent: "Africa",
    continentCode: "af",
    latitude: "-19.302233",
    linkedinHeadline: "Mozambique",
    linkedinId: "100474128",
    longitude: "34.9144977",
    name: {
      en: "Mozambique",
      es: "Mozambique",
      fr: "Mozambique",
      native: ["Mo\xE7ambique"]
    },
    population: 31689e3
  },
  {
    code: "na",
    continent: "Africa",
    continentCode: "af",
    latitude: "-23.2335499",
    linkedinHeadline: "Namibia",
    linkedinId: "106682822",
    longitude: "17.3231107",
    name: {
      en: "Namibia",
      es: "Namibia",
      fr: "Namibie",
      native: ["Namibia"]
    },
    population: 2555e3
  },
  {
    code: "nc",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-20.454288599999998",
    linkedinHeadline: "New Caledonia",
    linkedinId: "105535747",
    longitude: "164.55660583077983",
    name: {
      en: "New Caledonia",
      es: "Nueva Caledonia",
      fr: "Nouvelle Cal\xE9donie",
      native: ["Nouvelle-Cal\xE9donie"]
    },
    population: 29e4
  },
  {
    code: "ne",
    continent: "Africa",
    continentCode: "af",
    latitude: "17.7356214",
    linkedinHeadline: "Niger",
    linkedinId: "103550069",
    longitude: "9.3238432",
    name: {
      en: "Niger",
      es: "N\xEDger",
      fr: "Niger",
      native: ["Niger"]
    },
    population: 24746e3
  },
  {
    code: "nf",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-29.0289575",
    linkedinHeadline: "Norfolk Island",
    linkedinId: "100646662",
    longitude: "167.9587289126371",
    name: {
      en: "Norfolk Island",
      es: "Isla Norfolk",
      fr: "\xCEle de Norfolk",
      native: ["Norfolk Island"]
    },
    population: 2e3
  },
  {
    code: "ng",
    continent: "Africa",
    continentCode: "af",
    latitude: "9.6000359",
    linkedinHeadline: "Nigeria",
    linkedinId: "105365761",
    longitude: "7.9999721",
    name: {
      en: "Nigeria",
      es: "Nigeria",
      fr: "Nigeria",
      native: ["Nigeria"]
    },
    population: 213516e3
  },
  {
    code: "ni",
    continent: "North America",
    continentCode: "na",
    latitude: "12.6090157",
    linkedinHeadline: "Nicaragua",
    linkedinId: "105517145",
    longitude: "-85.2936911",
    name: {
      en: "Nicaragua",
      es: "Nicaragua",
      fr: "Nicaragua",
      native: ["Nicaragua"]
    },
    population: 6766e3
  },
  {
    code: "nl",
    continent: "Europe",
    continentCode: "eu",
    latitude: "52.5001698",
    linkedinHeadline: "Netherlands",
    linkedinId: "102890719",
    longitude: "5.7480821",
    name: {
      en: "Netherlands",
      es: "Pa\xEDses Bajos",
      fr: "Pays-Bas",
      native: ["Nederland"]
    },
    population: 17397e3
  },
  {
    code: "no",
    continent: "Europe",
    continentCode: "eu",
    latitude: "64.5731537",
    linkedinHeadline: "Norway",
    linkedinId: "103819153",
    longitude: "11.52803643954819",
    name: {
      en: "Norway",
      es: "Noruega",
      fr: "Norv\xE8ge",
      native: ["Norge", "Noreg"]
    },
    population: 5438e3
  },
  {
    code: "np",
    continent: "Asia",
    continentCode: "as",
    latitude: "28.1083929",
    linkedinHeadline: "Nepal",
    linkedinId: "104630404",
    longitude: "84.0917139",
    name: {
      en: "Nepal",
      es: "Nepal",
      fr: "N\xE9pal",
      native: ["\u0928\u0947\u092A\u093E\u0932"]
    },
    population: 30368e3
  },
  {
    code: "nr",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-0.5252306",
    linkedinHeadline: "Nauru",
    linkedinId: "100348836",
    longitude: "166.9324426",
    name: {
      en: "Nauru",
      es: "Nauru",
      fr: "Nauru",
      native: ["Nauru"]
    },
    population: 11e3
  },
  {
    code: "nu",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-19.0536414",
    linkedinHeadline: "Niue",
    linkedinId: "102139488",
    longitude: "-169.8613411",
    name: {
      en: "Niue",
      es: "Niue",
      fr: "Niue",
      native: ["Niue"]
    },
    population: 1600
  },
  {
    code: "nz",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-41.5000831",
    linkedinHeadline: "New Zealand",
    linkedinId: "105490917",
    longitude: "172.8344077",
    name: {
      en: "New Zealand",
      es: "Nueva Zelanda",
      fr: "Nouvelle-Z\xE9lande",
      native: ["New Zealand", "Aotearoa"]
    },
    population: 4993e3
  },
  {
    code: "om",
    continent: "Asia",
    continentCode: "as",
    latitude: "21.0000287",
    linkedinHeadline: "Oman",
    linkedinId: "103619019",
    longitude: "57.0036901",
    name: {
      en: "Oman",
      es: "Om\xE1n",
      fr: "Oman",
      native: ["\u0639\u0645\u0627\u0646"]
    },
    population: 5188e3
  },
  {
    code: "pa",
    continent: "North America",
    continentCode: "na",
    latitude: "8.559559",
    linkedinHeadline: "Panama",
    linkedinId: "100808673",
    longitude: "-81.1308434",
    name: {
      en: "Panama",
      es: "Panam\xE1",
      fr: "Panama",
      native: ["Panam\xE1"]
    },
    population: 4423e3
  },
  {
    code: "pe",
    continent: "South America",
    continentCode: "sa",
    latitude: "-6.8699697",
    linkedinHeadline: "Peru",
    linkedinId: "102927786",
    longitude: "-75.0458515",
    name: {
      en: "Peru",
      es: "Per\xFA",
      fr: "P\xE9rou",
      native: ["Per\xFA"]
    },
    population: 33813e3
  },
  {
    code: "pf",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-16.03442485",
    linkedinHeadline: "French Polynesia",
    linkedinId: "102681285",
    longitude: "-146.0490931059517",
    name: {
      en: "French Polynesia",
      es: "Polinesia Franc\xE9s",
      fr: "Polyn\xE9sie Fran\xE7aise",
      native: ["Polyn\xE9sie fran\xE7aise"]
    },
    population: 282e3
  },
  {
    code: "pg",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-5.6816069",
    linkedinHeadline: "Papua New Guinea",
    linkedinId: "100152180",
    longitude: "144.2489081",
    name: {
      en: "Papua New Guinea",
      es: "Pap\xFAa Nueva Guinea",
      fr: "Papouasie Nouvelle Guin\xE9e",
      native: ["Papua Niugini"]
    },
    population: 9119e3
  },
  {
    code: "ph",
    continent: "Asia",
    continentCode: "as",
    latitude: "12.7503486",
    linkedinHeadline: "Philippines",
    linkedinId: "103121230",
    longitude: "122.7312101",
    name: {
      en: "Philippines",
      es: "Filipinas",
      fr: "Philippines",
      native: ["Pilipinas"]
    },
    population: 111046e3
  },
  {
    code: "pk",
    continent: "Asia",
    continentCode: "as",
    latitude: "30.3308401",
    linkedinHeadline: "Pakistan",
    linkedinId: "101022442",
    longitude: "71.247499",
    name: {
      en: "Pakistan",
      es: "Pakist\xE1n",
      fr: "Pakistan",
      native: ["\u067E\u0627\u06A9\u0633\u062A\u0627\u0646"]
    },
    population: 225199e3
  },
  {
    code: "pl",
    continent: "Europe",
    continentCode: "eu",
    latitude: "52.215933",
    linkedinHeadline: "Poland",
    linkedinId: "105072130",
    longitude: "19.134422",
    name: {
      en: "Poland",
      es: "Polonia",
      fr: "Pologne",
      native: ["Polska"]
    },
    population: 37792e3
  },
  {
    code: "pm",
    continent: "North America",
    continentCode: "na",
    latitude: "46.783246899999995",
    linkedinHeadline: "Saint Pierre and Miquelon",
    linkedinId: "102024132",
    longitude: "-56.195158907484085",
    name: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquel\xF3n",
      fr: "Saint-Pierre-et-Miquelon",
      native: ["Saint-Pierre-et-Miquelon"]
    },
    population: 6e3
  },
  {
    code: "pn",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-25.0657719",
    linkedinHeadline: "Pitcairn Islands",
    linkedinId: "104322374",
    longitude: "-130.1017823",
    name: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      fr: "\xCEles Pitcairn",
      native: ["Pitcairn Islands"]
    },
    population: 50
  },
  {
    code: "pr",
    continent: "North America",
    continentCode: "na",
    latitude: "18.2214149",
    linkedinHeadline: "Puerto Rico",
    linkedinId: "105245958",
    longitude: "-66.41328179513847",
    name: {
      en: "Puerto Rico",
      es: "Puerto Rico",
      fr: "Porto Rico",
      native: ["Puerto Rico"]
    },
    population: 3194e3
  },
  {
    code: "ps",
    continent: "Asia",
    continentCode: "as",
    latitude: "31.7621153",
    linkedinHeadline: "Palestinian Authority",
    linkedinId: "93000000",
    longitude: "-95.6307891",
    name: {
      en: "Palestine",
      es: "Palestina",
      fr: "Palestine",
      native: ["\u0641\u0644\u0633\u0637\u064A\u0646"]
    },
    population: 5188e3
  },
  {
    code: "pt",
    continent: "Europe",
    continentCode: "eu",
    latitude: "40.0332629",
    linkedinHeadline: "Portugal",
    linkedinId: "100364837",
    longitude: "-7.8896263",
    name: {
      en: "Portugal",
      es: "Portugal",
      fr: "Portugal",
      native: ["Portugal"]
    },
    population: 10127e3
  },
  {
    code: "pw",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "7.3245000000000005",
    linkedinHeadline: "Palau",
    linkedinId: "106779877",
    longitude: "134.496454875",
    name: {
      en: "Palau",
      es: "Palau",
      fr: "Palau",
      native: ["Belau"]
    },
    population: 18e3
  },
  {
    code: "py",
    continent: "South America",
    continentCode: "sa",
    latitude: "-23.3165935",
    linkedinHeadline: "Paraguay",
    linkedinId: "104065273",
    longitude: "-58.1693445",
    name: {
      en: "Paraguay",
      es: "Paraguay",
      fr: "Paraguay",
      native: ["Paraguay"]
    },
    population: 7181e3
  },
  {
    code: "qa",
    continent: "Asia",
    continentCode: "as",
    latitude: "25.3336984",
    linkedinHeadline: "Qatar",
    linkedinId: "104170880",
    longitude: "51.2295295",
    name: {
      en: "Qatar",
      es: "Katar",
      fr: "Qatar",
      native: ["\u0642\u0637\u0631"]
    },
    population: 2817e3
  },
  {
    code: "re",
    continent: "Africa",
    continentCode: "af",
    latitude: "-21.130737949999997",
    linkedinHeadline: "Reunion",
    linkedinId: "104265812",
    longitude: "55.536480112992315",
    name: {
      en: "Reunion",
      es: "Reuni\xF3n",
      fr: "R\xE9union",
      native: ["R\xE9union"]
    },
    population: 895e3
  },
  {
    code: "ro",
    continent: "Europe",
    continentCode: "eu",
    latitude: "45.9852129",
    linkedinHeadline: "Romania",
    linkedinId: "106670623",
    longitude: "24.6859225",
    name: {
      en: "Romania",
      es: "Rumania",
      fr: "Roumanie",
      native: ["Rom\xE2nia"]
    },
    population: 19128e3
  },
  {
    code: "rs",
    continent: "Europe",
    continentCode: "eu",
    latitude: "44.1534121",
    linkedinHeadline: "Serbia",
    linkedinId: "101855366",
    longitude: "20.55144",
    name: {
      en: "Serbia",
      es: "Serbia",
      fr: "Serbie",
      native: ["\u0421\u0440\u0431\u0438\u0458\u0430"]
    },
    population: 6898e3
  },
  {
    code: "ru",
    continent: "Europe",
    continentCode: "eu",
    latitude: "64.6863136",
    linkedinHeadline: "Russia",
    linkedinId: "101728296",
    longitude: "97.7453061",
    name: {
      en: "Russia",
      es: "Rusia",
      fr: "Russie",
      native: ["\u0420\u043E\u0441\u0441\u0438\u044F"]
    },
    population: 144104e3
  },
  {
    code: "rw",
    continent: "Africa",
    continentCode: "af",
    latitude: "-1.9646631",
    linkedinHeadline: "Rwanda",
    linkedinId: "103547315",
    longitude: "30.0644358",
    name: {
      en: "Rwanda",
      es: "Ruanda",
      fr: "Rwanda",
      native: ["Rwanda"]
    },
    population: 13337e3
  },
  {
    code: "sa",
    continent: "Asia",
    continentCode: "as",
    latitude: "25.6242618",
    linkedinHeadline: "Saudi Arabia",
    linkedinId: "100459316",
    longitude: "42.3528328",
    name: {
      en: "Saudi Arabia",
      es: "Arabia Saudita",
      fr: "Arabie Saoudite",
      native: ["\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629"]
    },
    population: 35094e3
  },
  {
    code: "sb",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-8.7053941",
    linkedinHeadline: "Solomon Islands",
    linkedinId: "104980134",
    longitude: "159.10710973724628",
    name: {
      en: "Solomon Islands",
      es: "Islas Salom\xF3n",
      fr: "\xCEles Salomon",
      native: ["Solomon Islands"]
    },
    population: 708e3
  },
  {
    code: "sc",
    continent: "Africa",
    continentCode: "af",
    latitude: "-4.6574977",
    linkedinHeadline: "Seychelles",
    linkedinId: "107007050",
    longitude: "55.4540146",
    name: {
      en: "Seychelles",
      es: "Seychelles",
      fr: "Seychelles",
      native: ["Seychelles"]
    },
    population: 99e3
  },
  {
    code: "sd",
    continent: "Africa",
    continentCode: "af",
    latitude: "14.5844444",
    linkedinHeadline: "Sudan",
    linkedinId: "106740205",
    longitude: "29.4917691",
    name: {
      en: "Sudan",
      es: "Sud\xE1n",
      fr: "Soudan",
      native: ["\u0627\u0644\u0633\u0648\u062F\u0627\u0646"]
    },
    population: 43853e3
  },
  {
    code: "se",
    continent: "Europe",
    continentCode: "eu",
    latitude: "59.6749712",
    linkedinHeadline: "Sweden",
    linkedinId: "105117694",
    longitude: "14.5208584",
    name: {
      en: "Sweden",
      es: "Suecia",
      fr: "Su\xE8de",
      native: ["Sverige"]
    },
    population: 10379e3
  },
  {
    code: "sg",
    continent: "Asia",
    continentCode: "as",
    latitude: "1.3408630000000001",
    linkedinHeadline: "Singapore",
    linkedinId: "102454443",
    longitude: "103.83039182212079",
    name: {
      en: "Singapore",
      es: "Singapur",
      fr: "Singapour",
      native: ["Singapore", "\u65B0\u52A0\u5761"]
    },
    population: 5856e3
  },
  {
    code: "sh",
    continent: "Africa",
    continentCode: "af",
    latitude: "-15.9694573",
    linkedinHeadline: "Saint Helena, Ascension and Tristan da Cunha",
    linkedinId: "105392771",
    longitude: "-5.7129442",
    name: {
      en: "Saint Helena",
      es: "Santa elena",
      fr: "Sainte-H\xE9l\xE8ne",
      native: ["Saint Helena"]
    },
    population: 6e3
  },
  {
    code: "si",
    continent: "Europe",
    continentCode: "eu",
    latitude: "45.8133113",
    linkedinHeadline: "Slovenia",
    linkedinId: "106137034",
    longitude: "14.4808369",
    name: {
      en: "Slovenia",
      es: "Eslovenia",
      fr: "Slov\xE9nie",
      native: ["Slovenija"]
    },
    population: 2094e3
  },
  {
    code: "sj",
    continent: "Europe",
    continentCode: "eu",
    latitude: "78.51240255",
    linkedinHeadline: "Svalbard",
    linkedinId: "104980232",
    longitude: "16.60558240163109",
    name: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      native: ["Svalbard og Jan Mayen"]
    },
    population: 3e3
  },
  {
    code: "sk",
    continent: "Europe",
    continentCode: "eu",
    latitude: "48.7411522",
    linkedinHeadline: "Slovakia",
    linkedinId: "103119917",
    longitude: "19.4528646",
    name: {
      en: "Slovakia",
      es: "Eslovaquia",
      fr: "Slovaquie",
      native: ["Slovensko"]
    },
    population: 546e4
  },
  {
    code: "sl",
    continent: "Africa",
    continentCode: "af",
    latitude: "8.6400349",
    linkedinHeadline: "Sierra Leone",
    linkedinId: "106524187",
    longitude: "-11.8400269",
    name: {
      en: "Sierra Leone",
      es: "Sierra Leona",
      fr: "Sierra Leone",
      native: ["Sierra Leone"]
    },
    population: 8134e3
  },
  {
    code: "sm",
    continent: "Europe",
    continentCode: "eu",
    latitude: "43.9458623",
    linkedinHeadline: "San Marino",
    linkedinId: "105730022",
    longitude: "12.458306",
    name: {
      en: "San Marino",
      es: "San Marino",
      fr: "Saint Marin",
      native: ["San Marino"]
    },
    population: 34e3
  },
  {
    code: "sn",
    continent: "Africa",
    continentCode: "af",
    latitude: "14.4750607",
    linkedinHeadline: "Senegal",
    linkedinId: "103587512",
    longitude: "-14.4529612",
    name: {
      en: "Senegal",
      es: "Senegal",
      fr: "S\xE9n\xE9gal",
      native: ["S\xE9n\xE9gal"]
    },
    population: 17486e3
  },
  {
    code: "so",
    continent: "Africa",
    continentCode: "af",
    latitude: "8.3676771",
    linkedinHeadline: "Somalia",
    linkedinId: "104725424",
    longitude: "49.083416",
    name: {
      en: "Somalia",
      es: "Somalia",
      fr: "Somalie",
      native: ["Soomaaliya"]
    },
    population: 16323e3
  },
  {
    code: "sr",
    continent: "South America",
    continentCode: "sa",
    latitude: "4.1413025",
    linkedinHeadline: "Suriname",
    linkedinId: "105530931",
    longitude: "-56.0771187",
    name: {
      en: "Suriname",
      es: "Surinam",
      fr: "Suriname",
      native: ["Suriname"]
    },
    population: 6e5
  },
  {
    code: "ss",
    continent: "Africa",
    continentCode: "af",
    latitude: "7.8699431",
    linkedinHeadline: "South Sudan",
    linkedinId: "103622308",
    longitude: "29.6667897",
    name: {
      en: "South Sudan",
      es: "Sud\xE1n del Sur",
      fr: "Soudan du sud",
      native: ["South Sudan"]
    },
    population: 11196e3
  },
  {
    code: "st",
    continent: "Africa",
    continentCode: "af",
    latitude: "0.8875498",
    linkedinHeadline: "S\xE3o Tom\xE9 and Pr\xEDncipe",
    linkedinId: "106867470",
    longitude: "6.9648718",
    name: {
      en: "S\xE3o Tom\xE9 and Pr\xEDncipe",
      es: "Santo Tom\xE9 y Pr\xEDncipe",
      fr: "S\xE3o Tom\xE9 et Pr\xEDncipe",
      native: ["S\xE3o Tom\xE9 e Pr\xEDncipe"]
    },
    population: 219e3
  },
  {
    code: "sv",
    continent: "North America",
    continentCode: "na",
    latitude: "13.8000382",
    linkedinHeadline: "El Salvador",
    linkedinId: "106522560",
    longitude: "-88.9140683",
    name: {
      en: "El Salvador",
      es: "El Salvador",
      fr: "Salvador",
      native: ["El Salvador"]
    },
    population: 6533e3
  },
  {
    code: "sx",
    continent: "North America",
    continentCode: "na",
    latitude: "18.0423736",
    linkedinHeadline: "Saint Martin, Guernsey, Guernsey",
    linkedinId: "103917985",
    longitude: "-63.0549948",
    name: {
      en: "Saint Martin (Dutch part)",
      es: "San Mart\xEDn (Parte Holandesa)",
      fr: "Saint Martin (Partie N\xE9erlandaise)",
      native: ["Sint Maarten"]
    },
    population: 41e3
  },
  {
    code: "sy",
    continent: "Asia",
    continentCode: "as",
    latitude: "34.6401861",
    linkedinHeadline: "Syria",
    linkedinId: "106714035",
    longitude: "39.0494106",
    name: {
      en: "Syria",
      es: "Siria",
      fr: "Syrie",
      native: ["\u0633\u0648\u0631\u064A\u0627"]
    },
    population: 17812e3
  },
  {
    code: "sz",
    continent: "Africa",
    continentCode: "af",
    latitude: "-26.5624806",
    linkedinHeadline: "Eswatini",
    linkedinId: "106768907",
    longitude: "31.3991317",
    name: {
      en: "Eswatini",
      es: "Suazilandia",
      fr: "Eswatini",
      native: ["Swaziland"]
    },
    population: 1168e3
  },
  {
    code: "tc",
    continent: "North America",
    continentCode: "na",
    latitude: "21.7214683",
    linkedinHeadline: "Turks and Caicos Islands",
    linkedinId: "100771715",
    longitude: "-71.6201783",
    name: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      fr: "\xEEles Turques-et-Ca\xEFques",
      native: ["Turks and Caicos Islands"]
    },
    population: 38e3
  },
  {
    code: "td",
    continent: "Africa",
    continentCode: "af",
    latitude: "15.6134137",
    linkedinHeadline: "Chad",
    linkedinId: "104655384",
    longitude: "19.0156172",
    name: {
      en: "Chad",
      es: "Chad",
      fr: "Tchad",
      native: ["Tchad"]
    },
    population: 16923e3
  },
  {
    code: "tf",
    continent: "Antarctica",
    continentCode: "an",
    latitude: "-49.237441950000004",
    linkedinHeadline: "French Southern and Antarctic Lands",
    linkedinId: "104827874",
    longitude: "69.62275903679347",
    name: {
      en: "French Southern and Antarctic Lands",
      es: "Tierras Australes y Ant\xE1rticas Francesas",
      fr: "Terres Australes et Antarctiques Fran\xE7aises",
      native: ["Terres australes et antarctiques fran\xE7aises"]
    },
    population: 140
  },
  {
    code: "tg",
    continent: "Africa",
    continentCode: "af",
    latitude: "8.7800265",
    linkedinHeadline: "Togo",
    linkedinId: "103603395",
    longitude: "1.0199765",
    name: {
      en: "Togo",
      es: "Togo",
      fr: "Togo",
      native: ["Togo"]
    },
    population: 8499e3
  },
  {
    code: "th",
    continent: "Asia",
    continentCode: "as",
    latitude: "14.8971921",
    linkedinHeadline: "Thailand",
    linkedinId: "105146118",
    longitude: "100.83273",
    name: {
      en: "Thailand",
      es: "Tailandia",
      fr: "Tha\xEFlande",
      native: ["\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22"]
    },
    population: 70028e3
  },
  {
    code: "tj",
    continent: "Asia",
    continentCode: "as",
    latitude: "38.6281733",
    linkedinHeadline: "Tajikistan",
    linkedinId: "105925962",
    longitude: "70.8156541",
    name: {
      en: "Tajikistan",
      es: "Tayikist\xE1n",
      fr: "Tadjikistan",
      native: ["\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D"]
    },
    population: 9738e3
  },
  {
    code: "tk",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-9.1676396",
    linkedinHeadline: "Tokelau",
    linkedinId: "100212364",
    longitude: "-171.8196878",
    name: {
      en: "Tokelau",
      es: "Tokelau",
      fr: "Tokelau",
      native: ["Tokelau"]
    },
    population: 1500
  },
  {
    code: "tl",
    continent: "Asia",
    continentCode: "as",
    latitude: "-8.5151979",
    linkedinHeadline: "Timor-Leste",
    linkedinId: "101101678",
    longitude: "125.8375756",
    name: {
      en: "Timor-Leste",
      es: "Timor-Leste",
      fr: "Timor-Leste",
      native: ["Timor-Leste"]
    },
    population: 1338e3
  },
  {
    code: "tm",
    continent: "Asia",
    continentCode: "as",
    latitude: "39.3763807",
    linkedinHeadline: "Turkmenistan",
    linkedinId: "105449295",
    longitude: "59.3924609",
    name: {
      en: "Turkmenistan",
      es: "Turkmenist\xE1n",
      fr: "Turkm\xE9nistan",
      native: ["T\xFCrkmenistan"]
    },
    population: 6066e3
  },
  {
    code: "tn",
    continent: "Africa",
    continentCode: "af",
    latitude: "33.8439408",
    linkedinHeadline: "Tunisia",
    linkedinId: "102134353",
    longitude: "9.400138",
    name: {
      en: "Tunisia",
      es: "T\xFAnez",
      fr: "Tunisie",
      native: ["\u062A\u0648\u0646\u0633"]
    },
    population: 11904e3
  },
  {
    code: "to",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-19.9160819",
    linkedinHeadline: "Tonga",
    linkedinId: "105646927",
    longitude: "-175.2026424",
    name: {
      en: "Tonga",
      es: "Tonga",
      fr: "Tonga",
      native: ["Tonga"]
    },
    population: 1e5
  },
  {
    code: "tr",
    continent: "Europe",
    continentCode: "eu",
    latitude: "38.9597594",
    linkedinHeadline: "Turkey",
    linkedinId: "102105699",
    longitude: "34.9249653",
    name: {
      en: "Turkey",
      es: "Turqu\xEDa",
      fr: "Turquie",
      native: ["T\xFCrkiye"]
    },
    population: 85494e3
  },
  {
    code: "tt",
    continent: "North America",
    continentCode: "na",
    latitude: "10.8677845",
    linkedinHeadline: "Trinidad and Tobago",
    linkedinId: "106947126",
    longitude: "-60.9821067",
    name: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      fr: "Trinit\xE9-et-Tobago",
      native: ["Trinidad and Tobago"]
    },
    population: 14e5
  },
  {
    code: "tv",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-8.6405212",
    linkedinHeadline: "Tuvalu",
    linkedinId: "103609605",
    longitude: "179.1582918181797",
    name: {
      en: "Tuvalu",
      es: "Tuvalu",
      fr: "Tuvalu",
      native: ["Tuvalu"]
    },
    population: 11e3
  },
  {
    code: "tw",
    continent: "Asia",
    continentCode: "as",
    latitude: "23.9739374",
    linkedinHeadline: "Taiwan",
    linkedinId: "104187078",
    longitude: "120.9820179",
    name: {
      en: "Taiwan",
      es: "Taiw\xE1n",
      fr: "Ta\xEFwan",
      native: ["\u53F0\u7063"]
    },
    population: 238e5
  },
  {
    code: "tz",
    continent: "Africa",
    continentCode: "af",
    latitude: "-6.5247123",
    linkedinHeadline: "Tanzania",
    linkedinId: "104604145",
    longitude: "35.7878438",
    name: {
      en: "Tanzania",
      es: "Tanzania",
      fr: "Tanzanie",
      native: ["Tanzania"]
    },
    population: 61498e3
  },
  {
    code: "ua",
    continent: "Europe",
    continentCode: "eu",
    latitude: "49.4871968",
    linkedinHeadline: "Ukraine",
    linkedinId: "102264497",
    longitude: "31.2718321",
    name: {
      en: "Ukraine",
      es: "Ucrania",
      fr: "Ukraine",
      native: ["\u0423\u043A\u0440\u0430\u0457\u043D\u0430"]
    },
    population: 43913e3
  },
  {
    code: "ug",
    continent: "Africa",
    continentCode: "af",
    latitude: "1.5333554",
    linkedinHeadline: "Uganda",
    linkedinId: "106943612",
    longitude: "32.2166578",
    name: {
      en: "Uganda",
      es: "Uganda",
      fr: "Ouganda",
      native: ["Uganda"]
    },
    population: 47125e3
  },
  {
    code: "um",
    continent: "Oceania",
    continentCode: "oc",
    latitude: null,
    linkedinHeadline: null,
    linkedinId: null,
    longitude: null,
    name: {
      en: "United States Minor Outlying Islands",
      es: "Islas Menores Alejadas de los Estados Unidos",
      fr: "\xCEles Mineures \xC9loign\xE9es des \xC9tats-Unis",
      native: ["United States Minor Outlying Islands"]
    },
    population: 300
  },
  {
    code: "us",
    continent: "North America",
    continentCode: "na",
    latitude: "39.7837304",
    linkedinHeadline: "United States",
    linkedinId: "103644278",
    longitude: "-100.4458825",
    name: {
      en: "United States",
      es: "Estados Unidos",
      fr: "\xC9tats-Unis",
      native: ["United States"]
    },
    population: 33368e4
  },
  {
    code: "uy",
    continent: "South America",
    continentCode: "sa",
    latitude: "-32.8755548",
    linkedinHeadline: "Uruguay",
    linkedinId: "100867946",
    longitude: "-56.0201525",
    name: {
      en: "Uruguay",
      es: "Uruguay",
      fr: "Uruguay",
      native: ["Uruguay"]
    },
    population: 348e4
  },
  {
    code: "uz",
    continent: "Asia",
    continentCode: "as",
    latitude: "41.32373",
    linkedinHeadline: "Uzbekistan",
    linkedinId: "107734735",
    longitude: "63.9528098",
    name: {
      en: "Uzbekistan",
      es: "Uzbekistan",
      fr: "Ouzb\xE9kistan",
      native: ["O'zbekiston"]
    },
    population: 34192e3
  },
  {
    code: "va",
    continent: "Europe",
    continentCode: "eu",
    latitude: "41.9034912",
    linkedinHeadline: "Vatican City",
    linkedinId: "107163060",
    longitude: "12.4528349",
    name: {
      en: "Vatican City",
      es: "Ciudad del Vaticano",
      fr: "Vatican",
      native: ["Citt\xE0 del Vaticano"]
    },
    population: 800
  },
  {
    code: "vc",
    continent: "North America",
    continentCode: "na",
    latitude: "12.90447",
    linkedinHeadline: "St Vincent and the Grenadines",
    linkedinId: "104703990",
    longitude: "-61.2765569",
    name: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      fr: "Saint-Vincent-et-les-Grenadines",
      native: ["Saint Vincent and the Grenadines"]
    },
    population: 111e3
  },
  {
    code: "ve",
    continent: "South America",
    continentCode: "sa",
    latitude: "8.0018709",
    linkedinHeadline: "Venezuela",
    linkedinId: "101490751",
    longitude: "-66.1109318",
    name: {
      en: "Venezuela",
      es: "Venezuela",
      fr: "Venezuela",
      native: ["Venezuela"]
    },
    population: 28645e3
  },
  {
    code: "vg",
    continent: "North America",
    continentCode: "na",
    latitude: "18.4024395",
    linkedinHeadline: "British Virgin Islands",
    linkedinId: "105534858",
    longitude: "-64.5661642",
    name: {
      en: "British Virgin Islands",
      es: "Islas V\xEDrgenes Brit\xE1nicas",
      fr: "\xCEles Vierges Britanniques",
      native: ["British Virgin Islands"]
    },
    population: 3e4
  },
  {
    code: "vi",
    continent: "North America",
    continentCode: "na",
    latitude: "17.789187",
    linkedinHeadline: "US Virgin Islands",
    linkedinId: "102119762",
    longitude: "-64.7080574",
    name: {
      en: "United States Virgin Islands",
      es: "Islas V\xEDrgenes de los Estados Unidos",
      fr: "\xCEles Vierges Am\xE9ricaines",
      native: ["United States Virgin Islands"]
    },
    population: 104e3
  },
  {
    code: "vn",
    continent: "Asia",
    continentCode: "as",
    latitude: "13.2904027",
    linkedinHeadline: "Vietnam",
    linkedinId: "104195383",
    longitude: "108.4265113",
    name: {
      en: "Vietnam",
      es: "Vietnam",
      fr: "Vietnam",
      native: ["Vi\u1EC7t Nam"]
    },
    population: 98349e3
  },
  {
    code: "vu",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-16.5255069",
    linkedinHeadline: "Vanuatu",
    linkedinId: "102185308",
    longitude: "168.1069154",
    name: {
      en: "Vanuatu",
      es: "Vanuatu",
      fr: "Vanuatu",
      native: ["Vanuatu"]
    },
    population: 31e4
  },
  {
    code: "wf",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-14.30190495",
    linkedinHeadline: "Wallis and Futuna",
    linkedinId: "104246629",
    longitude: "-178.08997342208266",
    name: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      fr: "Wallis et Futuna",
      native: ["Wallis and Futuna"]
    },
    population: 11e3
  },
  {
    code: "ws",
    continent: "Oceania",
    continentCode: "oc",
    latitude: "-13.7693895",
    linkedinHeadline: "Samoa",
    linkedinId: "104031721",
    longitude: "-172.1200508",
    name: {
      en: "Samoa",
      es: "Samoa",
      fr: "Samoa",
      native: ["Samoa"]
    },
    population: 199e3
  },
  {
    code: "xk",
    continent: "Europe",
    continentCode: "eu",
    latitude: "42.5869578",
    linkedinHeadline: "Kosovo",
    linkedinId: "104640522",
    longitude: "20.9021231",
    name: {
      en: "Kosovo",
      es: "Kosovo",
      fr: "Kosovo",
      native: ["Kosov\xEB"]
    },
    population: 1811e3
  },
  {
    code: "ye",
    continent: "Asia",
    continentCode: "as",
    latitude: "16.3471243",
    linkedinHeadline: "Yemen",
    linkedinId: "105962095",
    longitude: "47.8915271",
    name: {
      en: "Yemen",
      es: "Yemen",
      fr: "Y\xE9men",
      native: ["\u0627\u0644\u064A\u0645\u0646"]
    },
    population: 30491e3
  },
  {
    code: "yt",
    continent: "Africa",
    continentCode: "af",
    latitude: "-12.823048",
    linkedinHeadline: "Mayotte",
    linkedinId: "104097939",
    longitude: "45.1520755",
    name: {
      en: "Mayotte",
      es: "Mayotte",
      fr: "Mayotte",
      native: ["Mayotte"]
    },
    population: 273e3
  },
  {
    code: "za",
    continent: "Africa",
    continentCode: "af",
    latitude: "-28.8166236",
    linkedinHeadline: "South Africa",
    linkedinId: "104035573",
    longitude: "24.991639",
    name: {
      en: "South Africa",
      es: "Sud\xE1frica",
      fr: "Afrique du Sud",
      native: ["South Africa", "Suid-Afrika"]
    },
    population: 60416e3
  },
  {
    code: "zm",
    continent: "Africa",
    continentCode: "af",
    latitude: "-14.5186239",
    linkedinHeadline: "Zambia",
    linkedinId: "102120260",
    longitude: "27.5599164",
    name: {
      en: "Zambia",
      es: "Zambia",
      fr: "Zambie",
      native: ["Zambia"]
    },
    population: 18652e3
  },
  {
    code: "zw",
    continent: "Africa",
    continentCode: "af",
    latitude: "-18.4554963",
    linkedinHeadline: "Zimbabwe",
    linkedinId: "101367137",
    longitude: "29.7468414",
    name: {
      en: "Zimbabwe",
      es: "Zimbabue",
      fr: "Zimbabwe",
      native: ["Zimbabwe"]
    },
    population: 14947e3
  }
];

const elasticIndices = [
  "apps",
  "business-types",
  "cities",
  "companies-v1",
  "companies-v2",
  "contacts",
  "continents",
  "counties",
  "countries",
  "ideateds",
  "industries-naics",
  "industries-sic",
  "industries",
  "industries-main",
  "job-titles",
  "monthly-visitors",
  "page-contents",
  "revenues",
  "social-networks",
  "states",
  "stock-exchanges",
  "technologies",
  "technology-categories",
  "tlds",
  "total-employees"
];
const elasticIndicesSchema = z.enum(elasticIndices);
const elasticSortFieldsMap = {
  "apps": "name.keyword",
  "business-types": "name.keyword",
  "cities": "code.keyword",
  "companies-v1": "domain.keyword",
  "companies-v2": "domain.domain.keyword",
  "contacts": "name.keyword",
  "continents": "code.keyword",
  "counties": "code.keyword",
  "countries": "code.keyword",
  "ideateds": "domain.keyword",
  "industries": "name.keyword",
  "industries-main": "name.keyword",
  "industries-naics": "code.keyword",
  "industries-sic": "code.keyword",
  "job-titles": "name.keyword",
  "monthly-visitors": "name.keyword",
  "page-contents": "url.keyword",
  "revenues": "name.keyword",
  "social-networks": "name.keyword",
  "states": "code.keyword",
  "stock-exchanges": "name.keyword",
  "technologies": "name.keyword",
  "technology-categories": "name.keyword",
  "tlds": "name.keyword",
  "total-employees": "name.keyword"
};
const proximityScoreMap = {
  close: 0.6,
  far: 0.1,
  near: 0.3
};

const fileExports = {
  formats: [
    "csv",
    "json",
    "txt",
    "xls",
    "xml"
  ]
};

const locales = [
  "en",
  "es",
  "fr"
];

const plansName = [
  "enterprise",
  "enterprise1M",
  "free",
  "scaleup",
  "startup"
];
const plans = {
  free: {
    credits: 500,
    development: {
      id: "",
      usd: {
        monthly: "",
        yearly: ""
      }
    },
    name: "free",
    pricing: {
      additionalCredits: 0,
      monthly: 0,
      yearly: 0
    },
    production: {
      id: "",
      usd: {
        monthly: "",
        yearly: ""
      }
    },
    restrictions: {
      maxScrollResults: 10 * 1e3,
      rateLimitPerSec: 30
    }
  },
  startup: {
    credits: 50 * 1e3,
    development: {
      id: "prod_PiegehyjihKIW7",
      usd: {
        monthly: "price_1OtDNBIAtBele9m0rUoi4huQ",
        yearly: "price_1OtDNXIAtBele9m0iW4xSNsC"
      }
    },
    name: "startup",
    pricing: {
      additionalCredits: 2.5,
      monthly: 95,
      yearly: 950
    },
    production: {
      id: "prod_PierC09ZTyfq2b",
      usd: {
        monthly: "price_1OtDXsIAtBele9m0YHbEsCOd",
        yearly: "price_1OtDXsIAtBele9m0BmQYeKjH"
      }
    },
    restrictions: {
      maxScrollResults: 100 * 1e3,
      rateLimitPerSec: 50
    }
  },
  scaleup: {
    credits: 250 * 1e3,
    development: {
      id: "prod_PieikgilrEpIhT",
      usd: {
        monthly: "price_1OtDPDIAtBele9m0O4y5H8Wl",
        yearly: "price_1OtDQ5IAtBele9m0p4vGEcEd"
      }
    },
    name: "scaleup",
    pricing: {
      additionalCredits: 1.75,
      monthly: 295,
      yearly: 2950
    },
    production: {
      id: "prod_PierpyZ9Gigiv4",
      usd: {
        monthly: "price_1OtDXtIAtBele9m0jmnQ6Ihk",
        yearly: "price_1OtDXtIAtBele9m0B8n3sDz0"
      }
    },
    restrictions: {
      maxScrollResults: 250 * 1e3,
      rateLimitPerSec: 250
    }
  },
  enterprise: {
    credits: 500 * 1e3,
    development: {
      id: "prod_PiekJS7QQmCaDm",
      usd: {
        monthly: "price_1OtDQqIAtBele9m0iZPSE2by",
        yearly: "price_1OtDR8IAtBele9m0ICP8OEKT"
      }
    },
    name: "enterprise",
    pricing: {
      additionalCredits: 1.5,
      monthly: 595,
      yearly: 5950
    },
    production: {
      id: "prod_PierW8ukWM6BZY",
      usd: {
        monthly: "price_1OtDXvIAtBele9m0YOrDV0Xu",
        yearly: "price_1OtDXvIAtBele9m01sbwH4hI"
      }
    },
    restrictions: {
      maxScrollResults: 500 * 1e3,
      rateLimitPerSec: 1e3
    }
  },
  enterprise1M: {
    credits: 1 * 1e3 * 1e3,
    development: {
      id: "prod_R61jZQSgegO17u",
      usd: {
        monthly: "price_1QDpfgIAtBele9m0P0M8hjh5",
        yearly: "price_1QDpg9IAtBele9m002lcVBBm"
      }
    },
    name: "enterprise-one-million",
    pricing: {
      additionalCredits: 1.5,
      monthly: 995,
      yearly: 9950
    },
    production: {
      id: "prod_R61LBhgWI6pmDE",
      usd: {
        monthly: "price_1QDpIiIAtBele9m0ylhnWi67",
        yearly: "price_1QDpJNIAtBele9m0cORWWEiA"
      }
    },
    restrictions: {
      maxScrollResults: 500 * 1e3,
      rateLimitPerSec: 1e3
    }
  }
};

const contexts = [
  "analytics",
  "api",
  "companies",
  "company",
  "documentation",
  "enrichment",
  "landing",
  "list",
  "similarity"
];
const features = [
  "ask",
  "cleanup",
  "enrich",
  "product",
  "search",
  "similar"
];
const models = ["small", "large"];

const prompts = {
  __proto__: null,
  contexts: contexts,
  features: features,
  models: models
};

const attributesWeCanQuery = [
  "about.businessType",
  "about.industries",
  "about.industry",
  "about.totalEmployees",
  "about.yearFounded",
  "ai.search",
  "analytics.monthlyVisitors",
  "apps",
  "codes.naics",
  "codes.sic",
  "contacts",
  "domain.domain",
  "domain.tld",
  "finances.revenue",
  "finances.stockExchange",
  "locations.headquarters.city.code",
  "locations.headquarters.continent.code",
  "locations.headquarters.country.code",
  "locations.headquarters.county.code",
  "locations.headquarters.state.code",
  "meta.listIds",
  "meta.score",
  "meta.syncedAt",
  "socials",
  "socials.linkedin.id",
  "technologies.active",
  "technologies.categories",
  "urls"
];
const attributesWeCanSearch = ["about.name", "domain.domain"];
const attributesWeCanSort = [
  "about.businessType",
  "about.industries",
  "about.industry",
  "about.name",
  "about.totalEmployees",
  "about.yearFounded",
  "analytics.monthlyVisitors",
  "apps",
  "codes.naics",
  "codes.sic",
  "contacts",
  "domain.domain",
  "domain.tld",
  "finances.revenue",
  "locations.headquarters.city.code",
  "locations.headquarters.country.code",
  "locations.headquarters.county.code",
  "locations.headquarters.state.code",
  "meta.score",
  "meta.syncedAt",
  "socials",
  "technologies.active",
  "urls"
];
const attributesWithBlockedOperator = [
  "about.businessType",
  "about.industry",
  "about.totalEmployees",
  "analytics.monthlyVisitors",
  "codes.naics",
  "codes.sic",
  "domain.tld",
  "finances.revenue",
  "finances.stockExchange",
  "locations.headquarters.city.code",
  "locations.headquarters.continent.code",
  "locations.headquarters.country.code",
  "locations.headquarters.county.code",
  "locations.headquarters.state.code"
];
const freeQueries$1 = {
  ask: "What products does this company offer?",
  domain: "microsoft.com",
  email: "john.michael.doe@microsoft.com",
  linkedin: "https://www.linkedin.com/company/microsoft",
  name: "microsoft",
  prompt: "universities in the united states"
};
function segmentationConditionsToQuery(conditions) {
  if (!conditions || conditions.length === 0) {
    return {
      object: {},
      string: ""
    };
  }
  const queryParams = {};
  for (const [index, condition] of conditions.entries()) {
    const { attribute, operator, sign, values } = condition;
    const valuesStr = values.join("~");
    if (!attribute || !operator || !sign || !valuesStr) {
      continue;
    }
    queryParams[`c${index + 1}`] = `${attribute}~${valuesStr}~${sign}~${operator}`;
  }
  return {
    object: queryParams,
    string: `${Object.entries(queryParams).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&")}`
  };
}
const segmentation = {
  attributesSimplified: companiesV2AttributesSimplified,
  attributesWeCanQuery,
  attributesWeCanSearch,
  attributesWeCanSort,
  attributesWithBlockedOperator,
  freeQueries: freeQueries$1,
  operators: allSegmentationOperators,
  segmentationConditionsToQuery,
  separator: segmentationSeparator,
  separatorForLocationCode: segmentationSeparatorForLocationCode,
  signs: allSegmentationSigns,
  sortOrder: segmentationSortOrder
};

const attributesWeCanQueryV1 = [
  "id",
  "city.code",
  "codeNaics",
  "codeSic",
  "continent.code",
  "country.code",
  "county.code",
  "domain",
  "industries",
  "industryMain",
  "monthlyVisitors",
  "revenue",
  "socialNetworks",
  "socialNetworks.linkedinIdAlpha",
  "state.code",
  "stockExchanges",
  "technologies",
  "technologyCategories",
  "totalEmployees"
];
const attributesWeCanSearchV1 = [
  "domain",
  "name",
  "nameAlts"
];
const attributesWeCanSortV1 = [
  "id",
  "score",
  "yearFounded"
];
const freeQueries = {
  domain: "gucci.com",
  email: "john.michael.doe@gucci.com",
  linkedin: "https://www.linkedin.com/company/gucci",
  name: "gucci"
};
const segmentationV1 = {
  attributesWeCanQueryV1,
  attributesWeCanSearchV1,
  attributesWeCanSortV1,
  freeQueries
};

const lastRanges = [
  {
    date: new Date(Date.now() - 1 * 60 * 60 * 1e3),
    value: "last1hour"
  },
  {
    date: new Date(Date.now() - 24 * 60 * 60 * 1e3),
    value: "last24hours"
  },
  {
    date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1e3),
    value: "last7days"
  },
  {
    date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1e3),
    value: "last30days"
  },
  {
    date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1e3),
    value: "last90days"
  },
  {
    date: new Date(Date.now() - 180 * 24 * 60 * 60 * 1e3),
    value: "last180days"
  },
  {
    date: new Date(Date.now() - 365 * 24 * 60 * 60 * 1e3),
    value: "last365days"
  }
];
const syncedRanges = { lastRanges };

export { analyticsData as a, countries as b, costs as c, plansName as d, prompts as e, fileExports as f, proximityScoreMap as g, segmentationV1 as h, syncedRanges as i, contexts as j, features as k, locales as l, models as m, elasticIndicesSchema as n, companiesV2Attributes as o, plans as p, companiesV2AttributesFirstLevel as q, companiesV2AttributesNextLevels as r, segmentation as s, companiesV2Categories as t, companiesV2CategoriesAndAttributes as u, elasticIndices as v, elasticSortFieldsMap as w };
